<template>
	<div style="overflow-y:auto;height:90vh;">

		<!-- Prospenct Info Header -->
		<div class="p-1 position-relative">
			<b-button variant="outline" class="deviceProsInfoTab position-absolute" @click="backToConvoListInDevice()">
				<v-icon name="times" scale="1" class="text-blue" />
			</b-button>
			<div class="titleBtnContainer">
				<!-- <b-button variant="outline-primary" class="editProspBtn" @click="toggleEdit">{{ edit ? 'Save' : 'Edit' }}</b-button> -->
				<!-- <h5 class="text-center titlePI">Prospect Information</h5> -->
			</div>

			<div class="ProspectActionDropDown">
				<b-dropdown text="Actions" variant="outline-primary">
					<b-dropdown-item href="#" @click="openMapProspect">Map Prospect</b-dropdown-item>
					<b-dropdown-item v-if="checkSubUser()" href="#" @click="toggleShare">Share Prospect</b-dropdown-item>
					<b-dropdown-item href="#" @click="openModal">Send Prospect to Manager</b-dropdown-item>
					<b-dropdown-item href="#" @click="$emit('delete')">Delete Prospect</b-dropdown-item>
				</b-dropdown>
			</div>

		</div>

		<!-- Prospenct Info Form -->
		<div class="w-90 mx-auto ProspectInfoInputs">
			<b-form @submit.stop.prevent="toggleEdit;toggleEditForScreening">
				<b-form-group label-cols="2" label="Status:" style="margin-top: 0.2rem !important;">
						<b-form-select
							class="col-8"
							:options="user.Stages"
							v-model="form.Status"
							@change="StatusDataOnChange()"
						>
							<b-form-select-option-group label="Default" @change="StatusDataOnChange()">
								<b-form-select-option v-if="user.Stages" :value="null">Uncategorized</b-form-select-option>
								<b-form-select-option v-if="user.Stages" :value="'Archived'">Archived</b-form-select-option>
							</b-form-select-option-group>
						</b-form-select>
				</b-form-group>
				<div class="contactContainer">
					<!-- <div class="contactInfo">
						<b-form-group label-cols="12" label-class="font-weight-bold" label="First Name:" class="my-1">
							<template v-if="edit">
							<b-form-input
								type="text"
								v-model="form.First"
								id="myInput"
								
								required />
							</template>
							<template v-else>
								<div class="my-1" label-cols="4">{{ form.First }}</div>
							</template>
						</b-form-group>
						<b-form-group label-cols="12" label-class="font-weight-bold" label="Last Name:" class="my-1">
							<template v-if="edit">
							<b-form-input
								type="text"
								:disabled="!edit"
								v-model="form.Last"
								/>
							</template>
							<template v-else>
								<div class="my-1" label-cols="4">{{ form.Last }}</div>
							</template>
						</b-form-group>
						<b-form-group label-cols="12" label-class="font-weight-bold" label="Email:" class="my-1">
							<template v-if="edit">
							<b-form-input
								type="email"
								:disabled="!edit"
								v-model="form.Email"
								/>
							</template>
							<template v-else>
								<div class="my-1" label-cols="4">{{ form.Email }}</div>
							</template>
						</b-form-group>
						<b-form-group label-cols="12" label-class="font-weight-bold" label="Phone number:" class="my-1">
							<template v-if="edit">
							<b-form-input
								type="tel"
								:disabled="!edit"
								placeholder="(xxx) xxx-xxxx"
								v-mask="'(###) ###-####'"
								v-model="form.Number"
								@change="savePhoneOnChange()"
								required />
							</template>
							<template v-else>
								<div class="my-1" label-cols="4">{{ form.Number }}</div>
							</template>
						</b-form-group>
						<b-form-group label-cols="12" label-class="font-weight-bold" label="Postal Code:" class="my-1">
							<template v-if="edit">
							<b-form-input
								:disabled="!edit"
								type="text"
								@keydown="isCheckPostalCode($event)"
								v-model="form.Zip"
								/>
							</template>
							<template v-else>
								<div class="my-1" label-cols="4">{{ form.Zip }}</div>
							</template>
						</b-form-group>
						<b-form-group label-cols="12" label="" class="my-1" v-if="form.Zip">
							<span style="color:#32398c;cursor:pointer;" href="#" @click="openMapProspect">{{this.displayCityName}}, {{this.displayStateName}}</span><br/>
							<span style="color:#32398c;cursor:pointer;" @click="clickAddAddressText">Add/View Address</span>
						</b-form-group>
					</div> -->
					
					<div class="screenCriteria">
						<div class="screeningTitle">
							Prospect Info
							<div class="button-container">
								<b-button variant="outline" @click="toggleEdit" class="edit-button">
								<template v-if="edit"><span class="save-button">Save</span></template>
								<template v-else>
									<v-icon class="text-blue" name="edit" />
								</template>
								</b-button>
							</div>
						</div>
						
						<div class="screeningData">
							<div class="screenDataRow">
								<div class="screenDataLabel">First Name:</div>
								<div class="screenDataValue">
									<template v-if="edit">
									<b-form-input
										type="text"
										v-model="form.First"
										id="myInput"
										
										required />
									</template>
									<template v-else>
										<div class="my-1" label-cols="4">{{ form.First }}</div>
									</template>
								</div>
							</div>
							<div class="screenDataRow">
								<div class="screenDataLabel">Last Name:</div>
								<div class="screenDataValue">
									<template v-if="edit">
									<b-form-input
										type="text"
										:disabled="!edit"
										v-model="form.Last"
										/>
									</template>
									<template v-else>
										<div class="my-1" label-cols="4">{{ form.Last }}</div>
									</template>
								</div>
							</div>
							<div class="screenDataRow">
								<div class="screenDataLabel">Email:</div>
								<div class="screenDataValue">
									<template v-if="edit">
									<b-form-input
										type="email"
										:disabled="!edit"
										v-model="form.Email"
										/>
									</template>
									<template v-else>
										<div class="my-1" label-cols="4">{{ form.Email }}</div>
									</template>
								</div>
							</div>
							<div class="screenDataRow">
								<div class="screenDataLabel">Phone number:</div>
								<div class="screenDataValue">
									<template v-if="edit">
									<b-form-input
										type="tel"
										:disabled="!edit"
										placeholder="(xxx) xxx-xxxx"
										v-mask="'(###) ###-####'"
										v-model="form.Number"
										@change="savePhoneOnChange()"
										required />
									</template>
									<template v-else>
										<div class="my-1" label-cols="4">{{ form.Number }}</div>
									</template>
								</div>
							</div>
							<div class="screenDataRow">
								<div class="screenDataLabel">Postal Code:</div>
								<div class="screenDataValue">
									<template v-if="edit">
									<b-form-input
										:disabled="!edit"
										type="text"
										@keydown="isCheckPostalCode($event)"
										v-model="form.Zip"
										/>
									</template>
									<template v-else>
										<div class="my-1" label-cols="4">{{ form.Zip }}</div>
									</template>
									<b-form-group class="my-1" v-if="form.Zip">
										<span style="color:#32398c;cursor:pointer;" href="#" @click="openMapProspect">{{this.displayCityName}}, {{this.displayStateName}}</span><br/>
										<span style="color:#32398c;cursor:pointer;" @click="clickAddAddressText">Add/View Address</span>
									</b-form-group>
								</div>
							</div>			
						</div>
						
					</div>
					<div class="screenCriteria">
						<div class="screeningTitle">
							Screening Info
							<div class="button-container">
								<b-button variant="outline" @click="editScreening ? toggleEditForScreeningSave() : toggleEditForScreening()" class="edit-button">
								<template v-if="editScreening"><span class="save-button">Save</span></template>
								<template v-else>
									<v-icon class="text-blue" name="edit" />
								</template>
								</b-button>
							</div>
						</div>
						<div class="screeningData" v-if="user.screeningCriteria">

							<div class="screenDataRow" v-for="(criteria, index) in tempDtata" :key="index">
								<div class="screenDataLabel">{{ friendlyName(criteria) }}:</div>
								<template v-if="editScreening">
									<b-form-select
										:disabled="!editScreening"
										:options="screeningDropdownValue(user.screeningCriteria, criteria)"
										@change="handleDropdownChange(criteria.name, $event)"
										v-model="prospect.screenCriteria[criteria.name]"
										:value="user.screeningCriteria[criteria.key]"
									>
								</b-form-select>
								</template>
								<template v-else>
									<div class="screenDataValue">
										<span v-if="prospect.screenCriteria !== null && prospect.screenCriteria" :style="matchCriteria(prospect.screenCriteria[criteria.name], user.screeningCriteria, criteria.name)" class="p-1">
											{{ prospect.screenCriteria[criteria.name] ? prospect.screenCriteria[criteria.name] : '-' }}
										</span>
										<span v-else>-</span>
									</div>
								</template>
							</div>


							<!-- <div class="screenDataRow">
								<div class="screenDataLabel">{{friendlyName('fullTime')}}:</div>
								<template v-if="edit">
									<b-form-select
											:disabled="!edit"
											:options="screeningDropdownValue(user.screeningCriteria,'commission')"
											v-model="screeningCriteria.commission"
										>
										</b-form-select>
								</template>
								<template v-else>
									<div class="screenDataValue"><span :style="(matchCriteria(prospect.screenCriteria.commission,user.screeningCriteria,'commission'))" class="p-1">{{ prospect.screenCriteria.commission }}</span></div>
								</template>
							</div> -->
							<!-- <div class="screenDataRow">
								<div class="screenDataLabel">{{friendlyName('fullTime')}}:</div>
								<template v-if="edit">
									<b-form-select
											:disabled="!edit"
											:options="screeningDropdownValue(user.screeningCriteria,'fullTime')"
											v-model="screeningCriteria.fulltime"
										>
										</b-form-select>
								</template>
								<template v-else>
									<div class="screenDataValue"><span :style="(matchCriteria(prospect.screenCriteria.fullTime,user.screeningCriteria,'fullTime'))" class="p-1">{{ prospect.screenCriteria.fullTime }}</span></div>
								</template>
							</div> -->
							<!-- <div class="screenDataRow">
								<div class="screenDataLabel">{{friendlyName('obtainLicense') ? friendlyName('obtainLicense') : '-'}}:</div>
								<template v-if="edit">
									<b-form-select
											:disabled="!edit"
											:options="screeningDropdownValue(user.screeningCriteria,'obtainLicense')"
											v-model="screeningCriteria.obtainlicense"
										>
										</b-form-select>
								</template>
								<template v-else>
									<div class="screenDataValue"><span :style="(matchCriteria(prospect.screenCriteria.obtainLicense,user.screeningCriteria,'obtainLicense'))" class="p-1">{{ prospect.screenCriteria.obtainLicense }}</span></div>
								</template>
							</div>
							<div class="screenDataRow">
								<div class="screenDataLabel">{{friendlyName('startupCosts') ? friendlyName('startupCosts') : '-'}}:</div>
								<template v-if="edit">
									<b-form-select
											:disabled="!edit"
											:options="screeningDropdownValue(user.screeningCriteria,'startupCosts')"
											v-model="screeningCriteria.startupcosts"
										>
										</b-form-select>
								</template>
								<template v-else>
									<div class="screenDataValue"><span :style="(matchCriteria(prospect.screenCriteria.startupCosts,user.screeningCriteria,'startupCosts'))" class="p-1">{{ prospect.screenCriteria.startupCosts }}</span></div>
								</template>
							</div>
							<div class="screenDataRow">
								<div class="screenDataLabel">Status:</div>
								<template v-if="edit">
									<b-form-select
											:disabled="!edit"
											:options="screeningDropdownValue(user.screeningCriteria,'status')"
											v-model="screeningCriteria.status"
										>
										</b-form-select>
								</template>
								<template v-else>
									<div class="screenDataValue"><span :style="(matchCriteria(prospect.screenCriteria.status,user.screeningCriteria,'status'))" class="p-1">{{ prospect.screenCriteria.status }}</span></div>
								</template>
							</div> -->
							<div class="screenDataRow">
								<div class="screenDataLabel">Date Updated:</div>
								<div class="screenDataValue">
									<span v-if="prospect.screenCriteria !== null && prospect.screenCriteria && prospect.screenCriteria.dateUpdated">
										{{ $parseDate(prospect.screenCriteria.dateUpdated) }}
									</span>
									<span v-else>-</span>
								</div>
							</div>
							<div class="screenDataRow">
								<div class="screenDataLabel">Updated By:</div>
								<div class="screenDataValue">
									<span v-if="prospect.screenCriteria !== null && prospect.screenCriteria && prospect.screenCriteria.updatedAuthor">
										{{ prospect.screenCriteria.updatedAuthor }}
									</span>
									<span v-else>-</span>
								</div>
							</div>
						</div>
						<!-- <div class="screeningData" v-else>
							<div class="screenDataRow">
								<div class="screenDataLabel">{{friendlyName('commission') !== 0 ? friendlyName('commission') : '-'}}:</div>
								<div class="screenDataValue"><span>-</span></div>
							</div>
							<div class="screenDataRow">
								<div class="screenDataLabel">{{friendlyName('fullTime') !== 0 ? friendlyName('fullTime') : '-'}}:</div>
								<div class="screenDataValue"><span>-</span></div>
							</div>
							<div class="screenDataRow">
								<div class="screenDataLabel">{{friendlyName('obtainLicense') !== 0 ? friendlyName('obtainLicense') : '-'}}:</div>
								<div class="screenDataValue"><span>-</span></div>
							</div>
							<div class="screenDataRow">
								<div class="screenDataLabel">{{friendlyName('startupCosts') !== 0 ? friendlyName('startupCosts') : '-'}}:</div>
								<div class="screenDataValue"><span>-</span></div>
							</div>
							<div class="screenDataRow">
								<div class="screenDataLabel">{{friendlyName('status') !== 0 ? friendlyName('status') : '-'}}:</div>
								<div class="screenDataValue"><span>-</span></div>
							</div>
							<div class="screenDataRow">
								<div class="screenDataLabel">Date Updated:</div>
								<div class="screenDataValue"><span>-</span></div>
							</div>
							<div class="screenDataRow">
								<div class="screenDataLabel">Author:</div>
								<div class="screenDataValue"><span>-</span></div>
							</div>
						</div> -->
					</div>
				</div>
				
				<!-- <div class="row mt-3">
					<div class="col-lg-6">
						<b-form-group label-cols="12" label="Status:">
								<b-form-select
									:disabled="!edit"
									:options="user.Stages"
									v-model="form.Status"
									@change="StatusDataOnChange()"
								>
									<b-form-select-option-group label="Default" @change="StatusDataOnChange()">
										<b-form-select-option v-if="user.Stages" :value="null">Uncategorized</b-form-select-option>
										<b-form-select-option v-if="user.Stages" :value="'Archived'">Archived</b-form-select-option>
									</b-form-select-option-group>
								</b-form-select>
						</b-form-group>
					</div>
					
				</div> -->
				
				<div class="tagsDivUI">
					<div class="custom-tag-content" >
						<div class="tags-header">
							<label class="col-form-label" label-cols="12" style="padding-left:0px !important">Tags:</label>
							<span class="custom-add-tags" @click="clickAddNewTags">Add tags</span>
						</div>
						<!-- <tags-input class="" 
							element-id="tags"
							v-model="selectedTags"
							:existing-tags="getExistingTags"
							:typeahead="this.setTypeaHead"
							typeahead-style="dropdown"
							:typeahead-activation-threshold=0
							:typeahead-hide-discard="true"
							@tag-added="onAddTag"
							placeholder="Type and Enter a New Tag"
							@focus="focusInputFieldTag"
							>
						</tags-input> -->
					</div>
				</div> 
				<div v-if="prospect && prospect.Tags && prospect.Tags.length"  class="d-flex mt-2 align-center custom-tag-content" >
					<!-- <label></label> -->
					<!-- <tags-input class="" element-id="tags1"
						v-model="selectedTags"
						:typeahead="true"
						typeahead-style="dropdown"
						@initialized="onInitialized"
						:disabled="true"
						:only-existing-tags="true">
					</tags-input> -->
					<div class="tags-custom">
						<div :key="i" v-for="i in prospect.Tags.length" class="tag-custom-wrapper"><p>{{prospect.Tags[i-1]}}</p><span @click="removeTag(prospect.Tags[i-1])">x</span></div>
					</div>
				</div>
					
				

				<!-- <b-form-group label-cols="4" label="Tags:" class="my-1">
					<b-form-checkbox-group v-model="form.Tags" :disabled="!edit">
						<b-form-checkbox :value="user.Folders[i-1]" :key="i" v-for="i in user.Folders.length">
							{{user.Folders[i-1]}}
						</b-form-checkbox>
					</b-form-checkbox-group>
				</b-form-group> -->				
				
				<b-form-checkbox
					v-if="!prospect"
					:disabled="!edit"
					v-model="optIn"
					value="optin"
					required>
						<small>This prospect has given me permission to contact them via text message</small>
				</b-form-checkbox>

				<b-form-group label-cols="12" label="Offices:" class="my-3" v-if="this.user.Version && this.user.Version == 2">
					<b-form-select @change="saveDataOnChange()" v-model="form.Office">
						<b-form-select-option :value="null">Please Select Office</b-form-select-option>
						<option :value="uof.OfficeId" :key="uof.OfficeId" v-for="uof in getSortedOfficeList">{{uof.OfficeName}}</option>
					</b-form-select>
				</b-form-group>

				<!-- <div class="flex-box-layout">
					<div class="">
						<b-form-group label="Interview Date/Time:" class="my-1" v-if="this.user.Version && this.user.Version == 2"></b-form-group>
						<b-form-group label="Interview Rating:" class="my-1 mt-4" v-if="this.user.Version && this.user.Version == 2"></b-form-group>
					</div>
					<div class="">
						<div class="" style="display: flex;gap: 4px;">
							<input type="checkbox" class="prspctcheckbox"
							v-model="InterviewedcheckBoxSelected" 
							@change="InterviewedcheckBox($event)" 
							/>  

							<b-form-datepicker
								@input="saveDataOnChange()"
								size="sm"
								class="dateInputalign prspctcheckboxinpt"
								style="margin-bottom: 5px"
								v-model="Interviewed"
								:disabled="InterviewedcheckBoxSelectedDisable"
							/>
						</div>
						
							<b-form-select 
							v-model="form.InterviewScore" 
							:options="InterviewScoreOptions"
							@change="InterviewScorChange(form.InterviewScore)"
							:disabled="InterviewedcheckBoxSelectedDisable"
							></b-form-select> -->
						
						<!-- <div class="timeInputUI">
							<b-form-group style="float:left;">
								<b-form-timepicker
									v-model="form.InterviewTime"
									class="getCurrentTime"
									size="sm"
									@hidden="InterviewedcheckBoxTime()"
									:disabled="InterviewedcheckBoxSelectedDisable"
									required/>
							</b-form-group>
						</div> -->

					<!-- </div>
					<div class="">
						<b-button variant="primary" class="scheduleBtn scheduleReminderBtn" @click="InterviewedSchedule()" :disabled="reminderBtnStatus">Schedule Reminder</b-button>
					</div>
				</div> -->
				
				<b-form-group label-cols="4" label="Interview Date/Time:" class="my-1" v-if="this.user.Version && this.user.Version == 2">

					<div class="row">
						<div class="col-md-9">

							<input type="checkbox" class="prspctcheckbox"
							v-model="InterviewedcheckBoxSelected" 
							@change="InterviewedcheckBox($event)" 
							/>  

							<b-form-datepicker
								@input="saveDataOnChange()"
								size="sm"
								class="dateInputalign prspctcheckboxinpt"
								style="margin-bottom: 5px"
								v-model="Interviewed"
								:disabled="InterviewedcheckBoxSelectedDisable"
							/>

							<div class="timeInputUI">
								<b-form-group style="float:left;">
									<b-form-timepicker
										v-model="form.InterviewTime"
										class="getCurrentTime"
										size="sm"
										@hidden="InterviewedcheckBoxTime()"
										:disabled="InterviewedcheckBoxSelectedDisable"
										required/>
								</b-form-group>
							</div>

						</div>
						<div class="col-md-3">
							<b-button variant="primary" class="scheduleBtn scheduleReminderBtn" @click="InterviewedSchedule()" :disabled="reminderBtnStatus">Schedule Reminder</b-button>
						</div>
					</div>
				</b-form-group>

				<b-form-group label-cols="4" label="Interview Rating:" class="my-1" v-if="this.user.Version && this.user.Version == 2">
					<b-form-select 
					v-model="form.InterviewScore" 
					:options="InterviewScoreOptions"
					@change="InterviewScorChange(form.InterviewScore)"
					:disabled="InterviewedcheckBoxSelectedDisable"
					></b-form-select>
				</b-form-group> 

				<b-form-group label-cols="4" label="Interview No-Show:" class="my-1" v-if="this.user.Version && this.user.Version == 2">

					<input type="checkbox" class="prspctcheckbox"
					v-model="InterviewNoShow" 
					@change="InterviewedNoShowcheckBox($event)"
					/>  
					<b-form-datepicker
						@input="InterviewedNoShowDateChange()"
						class="prspctcheckboxinpt"
						v-model="InterviewedShowDate"
						:disabled="InterviewedNoShowcheckBoxSelectedDisable"
					/>

				</b-form-group>

				
				
				<b-form-group label-cols="4" label="Hired Date:" class="my-1" v-if="this.user.Version && this.user.Version == 2">
	
					<input type="checkbox" class="prspctcheckbox" 
					v-model="HiredCheckBoxSelected" 
					@change="HiredcheckBox($event)" />

					<b-form-datepicker
						@input="saveDataOnChange()"
						size="sm"
						class="prspctcheckboxinpt"
						v-model="Hired"
						:disabled="HiredcheckBoxSelectedDisable"
					/>
				
				</b-form-group>

				<b-form-group label-cols="4" label="Lost to Competitor:" class="my-1" v-if="this.user.Version && this.user.Version == 2">
	
					<input type="checkbox" class="prspctcheckbox" 
					v-model="LosttoCompetitorCheckBoxSelected" 
					@change="LosttoCompetitorcheckBox($event)" />

					

					<b-form-datepicker
						@input="saveDataOnChange()"
						size="sm"
						class="prspctcheckboxinpt"
						v-model="LTC"
						:disabled="LosttoCompetitorcheckBoxSelectedDisable"
					/>

					<div class="CompetitorNameInputUI">
						<b-form-input
						@change="CompetitorNameDataOnChange()"
						type="text"
						v-model="form.CompetitorName"
						placeholder="Competitor Name"
						/>
					</div>
				
				</b-form-group>

				<!-- Form will not submit on enter without a button here -->
				<b-button type="submit" style="display: none"/>
			</b-form>

		<!-- {{abc()}} -->


			<!-- <b-button-group class="px-3 w-100"> -->
				<!-- <b-button v-if="!edit" variant="outline-primary" @click="toggleEdit">Edit</b-button>
				<b-button v-else variant="outline-primary" @click="toggleEdit">Save</b-button> -->
				<!-- <b-button variant="outline-primary" @click="$emit('delete')">Delete</b-button>
				<b-button v-if="checkSubUser()" variant="outline-primary" @click="toggleShare">Share Prospect</b-button> -->
				<!-- <b-button variant="outline-primary"><a v-bind:href="mailTo">Email Prospect</a></b-button> -->
				<!-- <b-button variant="outline-primary" @click="openMapProspect" >Map Prospect</b-button>
			</b-button-group> -->
			<!-- <b-button-group class="px-3 w-100" style="margin-top:5px">
				
				<b-button variant="outline-primary" @click="openModal" >Send Prospect to Manager</b-button>
			</b-button-group> -->
		</div>

		<!-- <div v-if="isShareClick" class="m-2 px-2 pt-2 bg-light border rounded">
			<div class="d-flex mb-2"> -->
				<!-- <b-form-group label-cols="4" label="Sub users:" class="my-1"> -->
					<!-- <div>Sub users </div>
					<b-form-select
						:options="options"
						v-model="selectedSubUser"
						class="flex-fill input form-control mx-1 p-2"
						@change="onSubUserChange">
					</b-form-select> -->
				<!-- </b-form-group> -->
				<!-- <div>
					<b-button variant="primary" class="p-2" @click="saveSharedProspect">Share</b-button>
				</div>
			</div>
			<div>
				<b-alert show variant="info">Shared Prospects will be sent with Notes history. Record any final notes before sharing prospect.</b-alert>
			</div>
		</div> -->

		<!-- Prospect Task -->
		<h5 v-if="prospect" class="text-center mt-2">Prospect Tasks</h5>
		<div v-if="prospect" class="m-2 px-2 pt-2 bg-light border rounded">
			<div class="d-flex mb-2  flex-grid wrapper-flex fromtopicker">
				<div v-if="user.Tasks" class="select-wrapper">
					<b-dropdown class="dropdown-wrapper" text="Select a task template" right variant="outline" toggle-class="text-blue" style="z-index: 999;margin-top: -8px;margin-left: -10px;">
						<b-dropdown-item :key="t" v-for="t in user.Tasks" @click="addSelectedTask(t)">{{t}}</b-dropdown-item>
						<!-- <b-dropdown-item>Second Action</b-dropdown-item> -->
						<!-- <b-dropdown-item>Third Action</b-dropdown-item> -->
					</b-dropdown>
				</div>
				<textarea
					ref="input"
					rows="1"
					class="flex-fill input form-control mx-1 p-2 textarea-box"
					placeholder="Create a new Task"
					v-model="taskName"
					@keydown.enter.prevent
					@keyup.enter="addTask"
					v-focus
					required
				/>
				<b-form-group label="Date/Time" class="text-left taskdatetimeinputUI" style="margin-top:5px;">
					<b-form-group class="fromtopickerinput">
						<b-form-datepicker
							:min="minDate"
							:max="maxDate"
							v-model="form.date"
							size="sm"
							required/>
						</b-form-group>
					<b-form-group class="fromtopickerinput">
						<b-form-timepicker
							v-model="form.time"
							size="sm"
							required/>
					</b-form-group>
				</b-form-group>
				<div class="addtaskSavebtn">
					<b-button variant="primary" class="p-2" @click="addTask">Save</b-button>
				</div>
			</div>
			<!-- <b-alert v-if="!isValidTask" show variant="danger"  dismissible>Please Add Task or Task Date/Time</b-alert> -->
			<b-alert
				variant="danger"
				dismissible
				fade
				:show="!isValidTask"
				@dismissed="isValidTask=true"
			>Please Add Task or Task Date/Time</b-alert>
			<b-table-simple v-if="prospect.Tasks" bordered striped responsive hover class="mx-auto text-left middle-grid-sc">
				<b-thead head-variant="light">
					<b-tr class="text-center">
						<b-th>Due Date</b-th>
						<b-th>Task</b-th>
					</b-tr>
				</b-thead>
				<!-- @click.native="focusedNote = datetime" 
				:class="{'pointer': prospect.Notes[datetime].length > 50}"-->
				<b-tbody>
					<b-tr
						:key="task.CreatedOn"
						v-for="task of TaskList"
						:class="HighLightNearByLast3DayTasks(task)"
						>
						<b-td>{{$parseDate(task.DueOn)}}</b-td>
						<b-td class="pr-5 position-relative">
							<span v-html="getConvertedText(task.Description)"></span>
							<b-button v-if="task.Status != 'compeleted'"
								style="right: 25px"
								variant="outline"
								class="center-vert"
								@click="compeleteTask(task)"
							>
								<v-icon class="text-blue" name="check" />
							</b-button>
							<b-button
								style="right: 0"
								variant="outline"
								class="center-vert"
								@click="removeTask(task)"
							>
								<v-icon class="text-blue" name="times" />
							</b-button>
							
						</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</div>

		<!-- Prospect Call Logs -->
		<h4 v-if="prospect &&  prospect.Calls" class="text-center mt-2">Call Logs</h4>
		<div v-if="prospect && prospect.Calls" class="m-2 px-2 pt-2 bg-light border rounded">
			<b-table-simple  bordered striped responsive hover class="mx-auto text-left">
				<b-thead head-variant="light">
					<b-tr class="text-center">
						<b-th>Date/Time</b-th>
						<b-th>Direction</b-th>
						<!-- <b-th>Status</b-th> -->
						<!-- <b-th>Duration</b-th> -->
					</b-tr>
				</b-thead>
				<b-tbody>
					<b-tr
						:key="calld.DateTime"
						class="text-left position-relative"
						
						v-for="calld of getCallLogs"
						
					>
					<!-- :class="{'pointer': prospect.Notes[datetime].length > 50}" 
					@click.native="focusedNote = datetime"-->
						<b-td class="text-center">{{$parsePlainDate(calld.DateTime)}} {{$parsePlainTimeWithSec(calld.DateTime)}}</b-td>
						<b-td class="text-center">{{calld.Direction}}
						<!-- <span v-html="getConvertedText(formatNote(datetime))"></span> -->
							<!-- {{formatNote(datetime)}} -->
							<!-- <b-button
								style="right: 0"
								variant="outline"
								class="center-vert"
								@click="removeNote(datetime)"
							>
								<v-icon class="text-blue" name="times" />
							</b-button> -->
						</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</div>
		<!-- Prospenct Notes -->
		<h5 v-if="prospect" class="text-center mt-2">Prospect Notes</h5>
		<div v-if="prospect" :class="{'notesTableUIList': !this.prospect.Notes}" class="m-2 px-2 pt-2 bg-light border rounded">
			<div class="d-flex mb-2">
				<textarea
					ref="input"
					rows="1"
					class="flex-fill input form-control mx-1 p-2"
					placeholder="Create a new Note"
					v-model="note"
					@keydown.enter.prevent
					@keyup.enter="addNote"
					v-focus
					style="width: 94%"
				/>
				<div>
					<input id="fileUploadNotes" type="file" @change="changeFileNotes($event)" hidden>
					<b-button  variant="outline" @click="chooseFilesNotes" class="fileUploadNotes">
						<v-icon name="upload" scale="1.5" class="text-blue" />
					</b-button>
					
					<b-dropdown class="customDropWithImg" title="Select Color">
						<b-dropdown-item
							:disabled="option.disabled"
							@click="selectOptionWithImg(option)"
							v-for="option in colorOptions"
							:key="option.value"
						>
							<div>
							<img :src="option.src">
							</div>
						</b-dropdown-item>
					</b-dropdown>

					<b-button variant="primary" class="addNoteBtn" @click="addNote">Save</b-button>
				</div>
			</div>
			<div v-if="hideDivNotes" class="border bg-light d-flex align-items-end p-2">
				<div style="position:relative;    display: flex;justify-content: space-between;width: 100%;">
					<span v-if="!uplodedFilePathNotes">Loading...</span>
					<a v-if="uplodedFilePathNotes && isImage" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePathNotes" >
						<img width="60" :src="uplodedFilePathNotes"/>
					</a>
					<a v-if="uplodedFilePathNotes && isAudio" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePathNotes" >
						<v-icon scale="2.5" name="music" />
					</a>
					<a v-if="uplodedFilePathNotes && isVideo" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePathNotes" >
						<v-icon scale="2.5" name="video" />
					</a>
					<a v-if="uplodedFilePathNotes && isDocument" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePathNotes" >
						<v-icon scale="2.5" name="file" />
					</a>
					<b-button variant="outline" class="p-0 mx-1 my-2 primary" @click="removeFileNotes">
						<v-icon name="times"  scale="1.5" class=" m-2 text-blue" />
					</b-button>
				</div>
			</div>
			<b-table-simple v-if="prospect.Notes" bordered striped responsive hover class="mx-auto text-left notesTableUI">
				<b-thead head-variant="light">
					<b-tr class="text-center">
						<b-th>Date/Time</b-th>
						<b-th>Notes</b-th>
						<!-- <b-th>Color</b-th> -->
						<b-th style="padding: 18px;"></b-th>
					</b-tr>
				</b-thead>
				<!-- <b-tbody>
					<b-tr
						:key="datetime"
						class="text-left position-relative"
						@click.native="focusedNote = datetime"
						v-for="datetime of sortDate"
						:class="{'pointer': prospect.Notes[datetime].length > 50}"
					>
						<b-td>{{$parseDate(datetime)}}</b-td>
						<b-td class="pr-5 position-relative">
						<span v-html="getConvertedText(formatNote(datetime))"></span>
							<b-button
								style="right: 0"
								variant="outline"
								class="center-vert"
								@click="removeNote(datetime)"
							>
								<v-icon class="text-blue" name="times" />
							</b-button>
						</b-td>
					</b-tr>
				</b-tbody> -->
				<b-tbody>
					<b-tr
						:key="i"
						class="text-left position-relative"
						@click.native="focusedNote = i"
						v-for="(item,i) in sortDate1"
						@click="clickedNote = i"
					>
						<b-td v-if="item.hasOwnProperty('color') && item.color" :style="`background-color:${item.color}`">{{$parseDate(item.date)}}</b-td>
						<b-td v-else>{{$parseDate(item.date)}}</b-td>
	
						<b-td v-if="item.color" :style="`background-color:${item.color}`">
						<span v-html="getConvertedText(formatNote1(i))"></span>
						<span v-if="item.mediaURL" style="float:right;">
							<a style="display:block;text-decoration: none" target="_blank" :href="item.mediaURL">
							<v-icon scale="2.5" name="file" />
							</a>
						</span>
						<!-- Conditionally render the dropdown -->
						<div v-if="clickedNote === i">
							<center>
							<b-dropdown :class="'tablecdwi notesdrpdwn customDropWithImg customDropWithImg'+item.date" text="Select Color" :style="`background-color:${item.color}`">
								<b-dropdown-item
								v-for="option in colorOptions"
								:key="option.value"
								:disabled="option.disabled"
								@click="selectOptionWithImgInside(option, item.date)"
								>
								<div>
									<img :src="option.src" />
								</div>
								</b-dropdown-item>
							</b-dropdown>
							</center>
						</div>
						</b-td>
						<b-td v-else>
						<span v-html="getConvertedText(formatNote1(i))"></span>
						<span v-if="item.mediaURL" style="float:right;">
							<a style="display:block;text-decoration: none" target="_blank" :href="item.mediaURL">
							<v-icon scale="2.5" name="file" />
							</a>
						</span>
						<!-- Conditionally render the dropdown -->
						<div v-if="clickedNote === i">
							<center>
							<b-dropdown :class="'tablecdwi customDropWithImg customDropWithImg'+item.date" text="Select Color">
								<b-dropdown-item
								v-for="option in colorOptions"
								:key="option.value"
								:disabled="option.disabled"
								@click="selectOptionWithImgInside(option, item.date)"
								>
								<div>
									<img :src="option.src" />
								</div>
								</b-dropdown-item>
							</b-dropdown>
							</center>
						</div>
						</b-td>
						
						<!-- <b-td v-else>
							<span v-html="getConvertedText(formatNote1(i))"></span>
							<span v-if="item.mediaURL" style="float:right;">
								<a style="display:block;text-decoration: none" target="blank" :href="item.mediaURL">
									<v-icon scale="2.5" name="file" />
								</a>
							</span>
						</b-td> -->
						

						

						<b-td v-if="item.hasOwnProperty('color') && item.color" :style="`background-color:${item.color}`">
							<b-button
								style="right: 0"
								variant="outline"
								class="center-vert"
								@click="removeNote1(item)"
							>
								<v-icon class="text-blue" name="times" />
							</b-button>
						</b-td>
						<b-td v-else>
							<b-button
								style="right: 0"
								variant="outline"
								class="center-vert"
								@click="removeNote1(item)"
							>
								<v-icon class="text-blue" name="times" />
							</b-button>
						</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</div>
		<br>

		<modal name="SendTOManagerModal" :draggable="true" >
			<h5 class="draghead">
				Send Prospect To Manager
				<span class="clstopop" @click="clstopop()"><v-icon name="times" class="icongrey" /></span>
			</h5>
			<b-form class="dragform">
				<b-form-group label="First Name: " class="text-left">
					<b-form-input v-model="mform.First" placeholder="First Name" required />
				</b-form-group>
				<b-form-group label="Last Name: " class="text-left">
					<b-form-input v-model="mform.Last" placeholder="Last Name" required />
				</b-form-group>
				<b-form-group label="Email: " class="text-left">
					<b-form-input v-model="mform.Email" placeholder="Email" required />
				</b-form-group>
				<b-form-group label="Phone Number: " class="text-left">
					<b-form-input
						type="tel"
						placeholder="(xxx) xxx-xxxx"
						v-mask="'(###) ###-####'"
						v-model="mform.Number"
						required />
				</b-form-group>
				<b-form-group label="Postal Code: " class="text-left">
					<b-form-input type="text" @keydown="isCheckPostalCode($event)" placeholder="Postal Code" v-model="mform.Zip"/>
				</b-form-group>

				<b-form-group label="Offices:" class="my-1" v-if="this.user.Version && this.user.Version == 2">
					<b-form-select @change="saveDataOnChange()" v-model="mform.Office" :disabled="true">
						<option :value="uof.OfficeId" :key="uof.OfficeId" v-for="uof in getSortedOfficeList">{{uof.OfficeName}}</option>
					</b-form-select>
				</b-form-group>

				<b-form-group label="Notes: " class="text-left">
					<b-form-textarea type="text" placeholder="Notes" v-model="mform.Notes"/>
				</b-form-group>
				<b-form-group  label="Manager:"  class="text-left">
					<b-form-select v-model="mform.MgrID" required>
						<!-- <b-form-select-option :value="null">Please select Manager</b-form-select-option> -->
						<b-form-select-option :value="mn.MgrID" :key="mn.MgrID" v-for="mn in user.Managers">{{mn.First}}  {{mn.Last}} - {{user.Offices.filter(o => o.MgrID === mn.MgrID).map(o => o.OfficeName).join(', ')}}</b-form-select-option>
					</b-form-select>
				</b-form-group>
				<b-form-group  label="CC Manager:"  class="text-left">
					<!-- <b-form-select v-model="mform.CCMgrID" required> -->
						<!-- <b-form-select-option :value="null">Please select Manager</b-form-select-option> -->
						<!-- <b-form-select-option :value="mn.MgrID" :key="mn.MgrID" v-for="mn in user.Managers">{{mn.First}}  {{mn.Last}} - {{mn.Office}}</b-form-select-option>
					</b-form-select> -->
					<multiselect 
						v-model="selectedCCValue" 
						tag-placeholder="Enter Manager" 
						placeholder="Search Manager"
						:options="getManagerList" 
						:multiple="true" 
						:taggable="true"
						:hideSelected="true"
						:showLabels='false'
						@tag="addCCEmail"
						>
					</multiselect>
				</b-form-group>
				<b-form-group label="Reminder Date" class="text-left">
					<b-form-group>
						<b-form-datepicker
							:min="new Date()"
							:max="maxDate"
							v-model="mform.remDate"
							size="sm"
							required/>
					</b-form-group>
				</b-form-group>
				<b-form-group label="Send Group Message:" label-cols="4" class="text-left ">
					<input type="checkbox" 
					v-model="mform.SendGroup"
					class="prspctcheckbox"
					@click="SendGroupField($event)"
					/>
				</b-form-group>
				<b-button block variant="outline-primary" @click="sendToManager">Send to Manager</b-button>
			</b-form>
		</modal>

		<b-modal id="addTagsPopup" hide-footer dialog-class="modal-dialog-scrollable">
			<template v-slot:modal-title>
				Add Tags
			</template>
			<div class="tagsDivUI">
				<div class="custom-tag-content" >
					<label class="col-12 bv-no-focus-ring col-form-label" label-cols="12" style="padding-left:0px !important">Create and Add New Tags:</label>
					<tags-input class="" 
						element-id="tags"
						v-model="selectedTags"
						:typeahead="this.setTypeaHead"
						typeahead-style="dropdown"
						:typeahead-activation-threshold=0
						:typeahead-hide-discard="true"
						@tag-added="onAddTag"
						placeholder="Type and Enter a New Tag"
						@focus="focusInputFieldTag"
						>
					</tags-input>
				</div>
				<div class="custom-tag-content" >
					<label class="col-12 bv-no-focus-ring col-form-label" label-cols="12" style="padding-left:0px !important">Add Existing Tags:</label>
					<div class="tags-custom">
						<div v-for="tag in getExistingTags" :key="tag.value" class="tag-custom-wrapper"><p>{{tag.value}}</p><span @click="updateTags(tag.value)">+</span></div>
					</div>
				</div>
			</div>
		</b-modal>

		<b-modal id="fullAddressPopup" hide-footer>
			<template v-slot:modal-title>
				Address
			</template>
			<div>
				<b-form>
					<b-form-group label="Full Address:" class="text-left" style="position:relative;">
						<b-form-input id="FullAdd" :disabled="disabledFullAddressField"
						:value="mergeFullAddress()"  />
						<span class="copybtn" @click="fullAddressCopyToClipboard()">Copy</span>
						<span class="copiedspan" style="display:none;">Copied</span>
					</b-form-group>
					<b-form-group label="Street Address:" class="text-left">
						<b-form-input placeholder="Enter ..." v-model="popupAddressStreet"  />
					</b-form-group>
					<b-form-group label="City:" class="text-left">
						<b-form-input placeholder="Enter ..." v-model="popupAddressCity" />
					</b-form-group>
					<b-form-group label="State:" class="text-left">
						<b-form-input placeholder="Enter ..." v-model="popupAddressState" />
					</b-form-group>
					<b-form-group label="Zip Code:" class="text-left">
						<b-form-input placeholder="Enter ..." v-model="popupAddressZip" />
					</b-form-group>
					<b-button variant="primary" class="addressSubmitBtn" @click="addressSubmitBtn()">Submit</b-button>
				</b-form>
			</div>
		</b-modal>


		<b-modal id="toggleShare" hide-footer>
			<template v-slot:modal-title>
				Share Prospect
			</template>
			<div  class="m-2 px-2 pt-2 bg-light border rounded">
				<div v-if="isShareClick" class="d-flex mb-2">
					<!-- <b-form-group label-cols="4" label="Sub users:" class="my-1"> -->
						<div>Sub users </div>
						<b-form-select
							:options="options"
							v-model="selectedSubUser"
							class="flex-fill input form-control mx-1 p-2"
							@change="onSubUserChange">
						</b-form-select>
					<!-- </b-form-group> -->
					<div>
						<b-button v-if="!isSharing" variant="primary" class="p-2" @click="saveSharedProspect">Share</b-button>
						<b-button v-if="isSharing" variant="primary" class="p-2">Sharing...</b-button>
					</div>
				</div>
				<div v-if="!isShareClick">
					<b-alert show variant="dark">Fetching the sub user list</b-alert>
				</div>
				<div>
					<b-alert show variant="info">Shared Prospects will be sent with Notes history. Record any final notes before sharing prospect.</b-alert>
				</div>
			</div>
		</b-modal>

		<b-modal id="ProspectMapModal" size="lg" title="Prospect Map"  hide-footer>
			<!-- <div>
				<MglMap class="custom-map"
					:accessToken="accessToken" 
					:mapStyle="mapStyle"
					:attributionControl="false"
					@load="onMapLoaded"
					@click="onJsonLayerClick"
					@mousemove="onJsonLayerMove"
				>
				
					<MglGeojsonLayer
						:sourceId="geoJsonSource.data.id"
						:source="geoJsonSource"
						layerId="somethingSomething"
						:layer="geoJsonLayer"
					/>
					<MglGeojsonLayer
						:sourceId="geoJsonSource2.data.id"
						:source="geoJsonSource2"
						:layerId="geoJsonLayer2.id"
						:layer="geoJsonLayer2"
					/>
					<MglNavigationControl position="top-left" />
					<MglFullscreenControl />
					<MglScaleControl :unit="'imperial'" />
					
					<MglMarker :coordinates="coordinates" color="blue" >
						<MglPopup>
							<div>{{this.prospect.First}} {{prospect.Last}}</div>
						</MglPopup>
					</MglMarker>
					<MglMarker :key="ofc.OfficeId" v-for="ofc in user.Offices" :coordinates="[ofc.longitude,ofc.latitude]" color="grey" >
						<MglPopup>
							<div>{{ofc.OfficeName}}</div>
						</MglPopup>
					</MglMarker>
				</MglMap>
				<div id="distance" class="distance-container"></div>
			</div> -->
			<div id="map"></div>
			<div id="distance" class="distance-container"></div>
		</b-modal>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import copyToClipboard from 'copy-to-clipboard';
	import { db,fbstore,getSubUserList,shareProspect,getPhoneData,updateProspectNumber,sentManager} from 'src/db.js'
	import axios from "axios";
	import Multiselect from 'vue-multiselect'
	// import VueMoment from 'vue-moment'
	// import moment from 'moment-timezone'
	import moment from 'moment';
	import Mapbox from "mapbox-gl";
	import * as turf from '@turf/turf'
	// import { 
	// 		MglMap,
	// 		MglMarker,
	// 		MglPopup,
	// 		// MglAttributionControl,
	// 		MglNavigationControl,
	// 		// MglGeolocateControl,
	// 		MglFullscreenControl,
	// 		MglScaleControl,
	// 		MglGeojsonLayer   
	// } from "vue-mapbox";

	import VoerroTagsInput from '@voerro/vue-tagsinput';

	export default {
		components: {
			// MglMap,
			// MglMarker,
			// MglPopup,
			// MglNavigationControl,
			// // MglGeolocateControl,
			// // MglAttributionControl,
			// MglFullscreenControl,
			// MglScaleControl,
			// MglGeojsonLayer
			"tags-input": VoerroTagsInput,
			Multiselect
		},
		name: "Prospect",
		props: {
			prospect: Object,
			number: String
		},
		computed: {
			getManagerList() {
				let Managers = [];
				for (let p of this.user.Managers) {
					if (p.First) {
						Managers.push(p.First+' '+p.Last+'-'+p.Office)
					}
				}
				return Managers
			},
			isImage() {
				let value =  false;
				if (this.uplodedFilePathNotes) {
					this.imageFormatArrayNotes.forEach(element => {
						if (this.uplodedFilePathNotes.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isAudio() {
				let value =  false;
				if (this.uplodedFilePathNotes) {
					this.audioFormatArrayNotes.forEach(element => {
						if (this.uplodedFilePathNotes.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isVideo() {
				let value =  false;
				if (this.uplodedFilePathNotes) {
					this.videoFormatArrayNotes.forEach(element => {
						if (this.uplodedFilePathNotes.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isDocument() {
				let value =  false;
				if (this.uplodedFilePathNotes) {
					this.documentFormatArrayNotes.forEach(element => {
						if (this.uplodedFilePathNotes.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			minDate() {
				return new Date();
			},
			maxDate() {
				let maxDate = new Date();
				maxDate.setDate(maxDate.getDate() + 365);
				return maxDate;
			},
			sortDate() {
				let o = this.prospect.Notes;
				let sortedDates  = Object.keys(o).sort().reduce((r, k) => (r[k] = o[k], r), {});
				return Object.keys(sortedDates).reverse();
			},
			sortDate1() {
				var cc = [];
				cc = Object.assign(cc,this.prospect.Notes);
				if(cc.length) {
					cc.sort((a, b) => b.date - a.date);
				}
				return cc;
			},
			getSortedOfficeList() {
				let aa = [];
				Object.assign(aa,this.user.Offices)
				return aa.sort(function(a, b){ return (a.OfficeName > b.OfficeName) ? 1 : -1;});
			},
			getCallLogs() {
				let o = this.prospect.Calls;
				return o.sort((m1, m2) => m1.DateTime - m2.DateTime).reverse();
			},
			TaskList() {
				let unCompeletedTaskList = [];
				if (this.prospect && this.prospect.Tasks) {
					for (let t of this.prospect.Tasks) {

						let utcdate = new Date(t.DueOn);

						var UTCDateTime = this.convertUTCDateTime(utcdate);

						var localeDateTime = this.convertToLocalDateTime(UTCDateTime);
						t.DueOn = localeDateTime;
						
						
						if (t.Status != 'compeleted') {
							unCompeletedTaskList.push(t);
						}
					}
				}
				unCompeletedTaskList.sort((a, b) => a.DueOn - b.DueOn).reverse();
				return unCompeletedTaskList;
			},
			getExistingTags() {
				let abc = [];
				this.user.Folders.forEach(element => {
					abc.push({key:element,value:element})
				});
				return abc
			},
			
			...mapState('firebase', ['prospects', 'convos', 'user']),
		},
		methods: {
			isOverDue(findProps) {
				let val = false;
				if(findProps && findProps.Tasks) {
					for (let task of findProps.Tasks) {
						if (task.DueOn && task.Status == 'draft' && (task.DueOn <= Date.now() || this.isToday(new Date(task.DueOn)))) {
							val = true;
							break	
						}
					}
					
				}
				return val
			},
			isToday(date) {
				const today = new Date()
				return date.getDate() === today.getDate() &&
					date.getMonth() === today.getMonth() &&
					date.getFullYear() === today.getFullYear();
			},
			sortedScreeningCriteria() {
				if(this.user && this.user.screeningCriteria){
					return this.user.screeningCriteria.slice().sort((a, b) => 
						this.friendlyName(a).localeCompare(this.friendlyName(b))
					);
				}
			},
			handleDropdownChange(key, selectedValue) {
				// //eslint-disable-next-line
				// console.log("value ::",key,selectedValue);
				this.screenCriteriaDrpdwn.push({key,value:selectedValue});
			},
			screeningDropdownValue(arr,field){
				const criterion = arr.find(item => item.name === field.name);
				if(criterion && criterion.possibleValues.length > 0){
					return criterion.possibleValues;
				}
				return [];
			},
			friendlyName(field){
				if(this.user && this.user.screeningCriteria){
					const criterion = this.user.screeningCriteria.find(item => item.name === field.name);
				if(criterion){
					return criterion.friendlyName;
				}else {
					return 0;
				}}
				return 0;
			},
			matchCriteria(prospect, criteria,field) {
				const criterion = criteria.find(item => item.name === field);
				var colorCode;
				if (prospect === "Unsure") {
					colorCode = 'background-color: #4d4a4a;color:white;';
				}
				if(criterion && criterion.approvedValues.length > 0){
					const isArray = criterion.approvedValues.includes(prospect);
				if(criterion === undefined){
					return;
				}
				if(isArray){
					colorCode = 'background-color: #2fca2f;';
				}else{
					colorCode = 'background-color: #fd4c4c;';
				}
				}
				return colorCode;
			},
			addCCEmail(newTag) {
				this.selectedCCValue.push(newTag);
			},
			// MANAGE IN MOBILE
			backToConvoListInDevice() {
				var ml = document.getElementById("MessageLog");
				if(ml) { ml.style.zIndex =""; }
				this.$store.commit('globals/CLEAR', 'activeProsp');
				this.$store.commit('globals/CLEAR', 'activeConvo');
			},
			// MERGE FULL ADDRESS
			mergeFullAddress() {
				if(this.popupAddressCity) {
					return `${this.popupAddressStreet} ${this.popupAddressCity}, ${this.popupAddressState} ${this.popupAddressZip}`;
				} else {
					return `${this.popupAddressStreet} ${this.popupAddressState} ${this.popupAddressZip}`;
				}
			},
			// CLICK TO COPYBOARD FULL ADDRESS
			fullAddressCopyToClipboard() {
				var copyText = document.getElementById("FullAdd");
				copyToClipboard(copyText.value);
				var editspan = document.getElementsByClassName("copiedspan")[0];
				if(editspan) {
					editspan.style.display = "block";
					setTimeout(() => {
						editspan.style.display = "none";
					}, 2000);
				}
				/*copyText.select();
				copyText.setSelectionRange(0, 99999); // For mobile devices
				navigator.clipboard.writeText(copyText.value);
				var editspan = document.getElementsByClassName("copiedspan")[0];
				if(editspan) {
					editspan.style.display = "block";
					setTimeout(() => {
						editspan.style.display = "none";
					}, 2000);
				}*/
			},
			// STORE IMAGE DROPDOWN VALUE
			selectOptionWithImg(option) {
				this.colorSelected = option;
				document.getElementsByClassName("customDropWithImg")[0].style.backgroundColor = `${this.colorSelected.value}`;
			},
			// STORE IMAGE DROPDOWN VALUE TABLE
			selectOptionWithImgInside(option, date) {
				document.getElementsByClassName("customDropWithImg"+date)[0].style.backgroundColor = `${option.value}`;
				var w = this.prospect.Notes.find(s=>s.date == date);
				w['color'] = option.value;
				if(w) {
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({ Notes: this.prospect.Notes })
				}
			},
			// ADDRESS SUBMIT
			addressSubmitBtn() {
				let dataa = { 
					StreetAddress: this.popupAddressStreet, 
					City: this.popupAddressCity, 
					State: this.popupAddressState,
					Zip: this.popupAddressZip
				}
				db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update(dataa);
				alert("Address Successfully Updated");
				this.$bvModal.hide('fullAddressPopup');
			},
			// OPEN ADDRESS POPUP
			clickAddAddressText() {
				this.$bvModal.show('fullAddressPopup');
			},
			clickAddNewTags(){
				this.$bvModal.show('addTagsPopup');
			},
			chooseFilesNotes() {
				document.getElementById("fileUploadNotes").click()
			},
			changeFileNotes(event) {
				this.uploadValueNotes = 0;
				this.uplodedFilePathNotes = '';
				this.fileDataNotes = event.target.files[0];
				if (this.supportedTypeNotes.includes(this.fileDataNotes.type)) {
					if (this.fileDataNotes.size < 5242880) {
						this.hideDivNotes = true;
						this.onUploadNotes();
					}else {
						alert('File size must be less than 5MB');
					}
				}else {
					alert('This format is not allowed');
				}
			},
			onUploadNotes(){
				this.uplodedFilePathNotes = '';
				const storageRef = fbstore.ref('Notes/'+this.fileDataNotes.name).put(this.fileDataNotes);
				// const storageRef = fbstore.ref(`${this.fileDataNotes.name}`).put(this.fileDataNotes);
				storageRef.on(`state_changed`,snapshot=>{
					this.uploadValueNotes = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
				}, error=>{
					//eslint-disable-next-line
					console.log(error.message)
				},
				()=>{this.uploadValueNotes=100;
					storageRef.snapshot.ref.getDownloadURL().then((url)=>{
						this.uplodedFilePathNotes = url;
						// this.send({});
					});
				});
			},
			removeFileNotes() {
				this.uplodedFilePathNotes = '';
				this.hideDivNotes = false;
				var storageRef = fbstore.ref().child('Notes/'+this.fileDataNotes.name);
				storageRef.delete();
			},
			clstopop() {
				this.$modal.hide('SendTOManagerModal');
			},
			// abc() {
			// 	// this.user.Offices = this.user.Offices.sort(function(a, b){ return (a.OfficeName > b.OfficeName) ? 1 : -1;});
			// 	//eslint-disable-next-line
			// 	//                 console.log(this.user.Offices.sort(function(a, b){
			// 	//     return (a.OfficeName > b.OfficeName) ? 1 : -1;
			// 	//   }));
			// },
			focusInputFieldTag() {
				this.setTypeaHead=true;
			},
			SendGroupField(e) {  
				this.setTypeaHead=false;
				let SendGroupFieldValue = e.target.checked;
				db.doc(`Users/${this.user.id}`).update({SendGroup:SendGroupFieldValue});
			},
			// INTERVIEW NO SHOW DATE CHANGE VALUE UPDATE 
			InterviewedNoShowDateChange() {
				let ms = new Date(`${this.InterviewedShowDate}`).valueOf();
				db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({InterviewShow:ms});
			},
			// INTERVIEW CHECKBOX
			InterviewedNoShowcheckBox(e) {
				/*
				let InterviewShow = e.target.checked;
				db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({InterviewShow:InterviewShow});
				*/
				if(e.target.checked == true) {
					this.InterviewedNoShowcheckBoxSelectedDisable = false;
					this.InterviewedShowDate = new Date() + (3600000*9); // DISPLAY PURPOSE
					let InterviewedShowDate1 = new Date(`${this.InterviewedShowDate}`).valueOf();
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({InterviewShow:InterviewedShowDate1});

					// REMOVE INTERVIEW DATE/TIME
					this.Interviewed = '';
					this.form.InterviewTime = '';
					this.form.InterviewScore = '';
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Interviewed:'', InterviewScore: ''});

				} else {
					this.InterviewedNoShowcheckBoxSelectedDisable = true;
					this.InterviewedShowDate = '';
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({InterviewShow:''});
				}
			},
			// INTERVIEW SCORE
			InterviewScorChange(InterviewScoreSelectedValue) {
				let InterviewScore = InterviewScoreSelectedValue;
				db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({InterviewScore:InterviewScore});

				if(this.prospect.hasOwnProperty('SentToManager')) {
					this.prospect.SentToManager.forEach(f=> {
						//eslint-disable-next-line
						console.log('f', f);
					});
				}
				
			},
			// APPOINTMENT TAGS
			appointmentTags(AppointmentReminderTime, managerName) {
				let res;
				let str = AppointmentReminderTime;
				res = str.replace(/{{ManagerName}}/g, managerName ? managerName : '');
				res = res.replace(/{{ProspectFirstName}}/g, this.prospect.First ? this.prospect.First : '');
				res = res.replace(/{{ProspectFullName}}/g, this.prospect.First || this.prospect.Last ? this.prospect.First+  ' ' +this.prospect.Last : '');
				res = res.replace(/{{UserName}}/g, this.user.First || this.user.Last ? this.user.First+ ' ' +this.user.Last : '');
				return res;
			},
			async InterviewedSchedule() {
				//eslint-disable-next-line
				console.log('this.form.InterviewTime', this.form.InterviewTime);
				this.InterviewedcheckBoxTime();
				if(this.form.Office && this.Interviewed && this.form.InterviewTime) 
				{
					let CurrentTimeWithUp24H = new Date().valueOf() + (60 * 60 * 1000 * 24);
                    let SelectedTime = new Date(`${this.Interviewed} ${this.form.InterviewTime}`).valueOf();
                    if(CurrentTimeWithUp24H <= SelectedTime) 
					{
						this.reminderBtnStatus = true;
						// MANAGER 
						let getOfficeData = this.user.Offices.find(um => um.OfficeId == this.form.Office);
						let managerName;
						if(getOfficeData.MgrID) {
							let a = this.user.Managers.find(um => um.MgrID == getOfficeData.MgrID);
							managerName = a.First+' '+a.Last;
							//eslint-disable-next-line
							console.log('managerName', managerName);
						} else {
							managerName = '';
						}

						let now_utc = new Date(`${this.Interviewed} ${this.form.InterviewTime}`).valueOf();
						if (this.form.InterviewTime == '') {
							now_utc = now_utc + (3600000*9);
						}
					
						// SET A TASK FOR 24 HOURS BEFORE
						let now_utc1 = now_utc - (24 * 60 * 60 * 1000);
						const taskDataBefore24h = {
							pid: this.user.id,
							cid: this.prospect.id,
							taskName: 'Interview Reminder: Interview Scheduled for '+moment(new Date(now_utc)).format('MMMM DD, YYYY hh:mm A')+' with '+managerName+' ',
							dueDate:now_utc1,
						};
						await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/createTask", taskDataBefore24h)
						.then(response => {
							// eslint-disable-next-line
							console.log(response);
						});

						this.reminderBtnStatusCount = this.reminderBtnStatusCount + 1;
						
						// SET A TASK FOR 1 HOURS AFTER
						// let now_utc2 = now_utc - (60 * 60 * 1000);
						let now_utc2 = now_utc;
						const taskDataAfter1h = {
							pid: this.user.id,
							cid: this.prospect.id,
							taskName: 'Interview Feedback: Interview Scheduled for '+moment(new Date(now_utc)).format('MMMM DD, YYYY hh:mm A')+' with '+managerName+' ',
							dueDate:now_utc2,
						};
						await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/createTask", taskDataAfter1h)
						.then(response => {
							// eslint-disable-next-line
							console.log(response);
						});

						this.reminderBtnStatusCount = this.reminderBtnStatusCount + 1;
						
						alert("Reminder has been successfully added.");

						if(this.reminderBtnStatusCount == 2) {
							this.reminderBtnStatusCount = 0;
							this.reminderBtnStatus = false;
						}

						/*
						// SET A MESSAGE FOR 24 HOURS BEFORE
						const smsData1 = {
							pid:this.user.id,
							cid: this.prospect.id,
							body: this.appointmentTags(this.user.AutoAppointment24h, managerName),
							SendOn:now_utc1,
							mediaUrl:'',
						};
						await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/automatedSms", smsData1)
						.then(response => {
							// eslint-disable-next-line
							console.log(response);
						}).catch(err => alert(`Failure scheduling message: ${err}`));

						// SET A MESSAGE FOR 1 HOURS BEFORE
						let now_utc3 = now_utc - (60 * 60 * 1000);
						const smsData = {
							pid:this.user.id,
							cid: this.prospect.id,
							body:this.appointmentTags(this.user.AutoAppointment1h, managerName),
							SendOn:now_utc3,
							mediaUrl:'',
						};
						await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/automatedSms", smsData)
						.then(response => {
							// eslint-disable-next-line
							console.log(response);
						}).catch(err => alert(`Failure scheduling message: ${err}`));
						*/
						
					} else {
                        alert('Interview must be at least 24 hours in the future in order to schedule automatic reminders.');
                    }
				
				} else {
					alert('Please Select Office, Interview Date and Time');
				}
			},
			// CREATE TASK FOR SCHEDULE COMMAN FUNCTION
			createTaskCommonFunc(taskData) {
				axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/createTask", taskData)
				.then(response => {
					// eslint-disable-next-line
					console.log(response);
					alert("Reminder Added Successfully");
				});
				
			},
			InterviewedcheckBoxTime() {
				let ms = new Date(`${this.Interviewed} ${this.form.InterviewTime}`).valueOf();
				db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Interviewed:ms});
			},
			InterviewedcheckBox(e) {  
				if(e.target.checked == true) {

					this.InterviewedcheckBoxSelectedDisable = false;
					// this.Interviewed = new Date() + (3600000*9); // DISPLAY PURPOSE
					this.Interviewed = new Date(); // DISPLAY PURPOSE
					this.form.InterviewTime = `${this.Interviewed.getHours()}:${this.Interviewed.getMinutes()}:00`;
					
					let InterviewedTime = new Date(`${this.Interviewed}`).valueOf(); // CONVERT TO TIMESTAMP
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Interviewed:InterviewedTime});

					// REMOVE INTERVIEW NO SHOW
					this.InterviewedShowDate = '';
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({InterviewShow:''});
				} else {
					this.InterviewedcheckBoxSelectedDisable = true;
					this.Interviewed = '';
					this.form.InterviewScore = '';
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Interviewed:'', InterviewScore:''}); // IF THE CHECKBOX IS UNCHECKED, INTERVIEWED VALUE UPDATE
					this.form.InterviewTime = '';
				}
			},  
			HiredcheckBox(e) { 

				var StatusArray1 = [];
				if(this.Stages != null || this.Stages != undefined) {
					StatusArray1 = this.Stages;
				}

				if(e.target.checked == true) {
					this.HiredcheckBoxSelectedDisable = false;
					this.Hired = new Date() + (3600000*9); // DISPLAY PURPOSE
					let HiredTime = new Date(`${this.Hired}`).valueOf(); // CONVERT TO TIMESTAMP

					// UPDATE STAGES ARRAY + STATUS
					let StatusName = 'Hired';

					this.checkStageExistOrNot(StatusName);
					
					let StatusArray2 = [{Date:HiredTime, Stage:StatusName}];
					let StatusArrayFinalOutput = [...StatusArray1, ...StatusArray2];
					let updatedForm = { Stages: StatusArrayFinalOutput, Status:StatusName, Hired:HiredTime }

					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update(updatedForm);

					// CREATE NEW TASK DURING STATUS CHANGE
					this.changeStatusinsertTheNewTask(StatusName);

				} else {
					this.HiredcheckBoxSelectedDisable = true;
					this.Hired = '';
					if(StatusArray1.length > 0) {
						let secondLastIndexStatus = StatusArray1[StatusArray1.length - 2].Stage;
						this.Stages.splice(StatusArray1.length - 1, 1); // DELETE LAST INDEX ARRAY
						let updatedForm3 = { Stages: this.Stages, Status: secondLastIndexStatus, Hired:'' }
						db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update(updatedForm3);
					} else {
						db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Hired:''}); // IF THE CHECKBOX IS UNCHECKED, HIRED VALUE UPDATE
					}
				}
			},
			// CHECK STAGE EXIST OR NOT IT NOT THEN CREATE ONE
			checkStageExistOrNot(StatusName)
			{
				var convertCurrentStagesToUppercase = String(this.user.Stages).toUpperCase().split(",");
				var currentStageToUppercase = StatusName.toUpperCase(); // CONVERT CURRENT STAGE UPPER CASE
				var check = convertCurrentStagesToUppercase.includes(currentStageToUppercase);
				if(!check) { // IF VALUE IS NOT EXIST, PUSH IN ARRAY (true,false)
					this.user.Stages.push(StatusName);
					let updatedForm1 = { Stages: this.user.Stages }
					db.doc(`Users/${this.user.id}`).update(updatedForm1);
				}
			},
			LosttoCompetitorcheckBox(e) 
            { 
				var StatusArray1 = [];
				if(this.Stages != null || this.Stages != undefined) {
					StatusArray1 = this.Stages;
				}

				if(e.target.checked == true) {
					this.LosttoCompetitorcheckBoxSelectedDisable = false;
					this.LTC = new Date() + (3600000*9); // DISPLAY PURPOSE
					let LTCTime = new Date(`${this.LTC}`).valueOf(); // CONVERT TO TIMESTAMP
					
					// UPDATE STAGES ARRAY + STATUS
					let StatusName = 'Lost to Competitors';

					this.checkStageExistOrNot(StatusName);

					let StatusArray2 = [{Date:LTCTime, Stage:StatusName}];
					let StatusArrayFinalOutput = [...StatusArray1, ...StatusArray2];
					let updatedForm = { Stages: StatusArrayFinalOutput, Status:StatusName, LTC:LTCTime }
					
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update(updatedForm);

					// CREATE NEW TASK DURING STATUS CHANGE
					this.changeStatusinsertTheNewTask(StatusName);
				
				} else {
					this.LosttoCompetitorcheckBoxSelectedDisable = true;
					this.LTC = '';
					if(StatusArray1.length > 0) {
						let secondLastIndexStatus = StatusArray1[StatusArray1.length - 2].Stage;
						this.Stages.splice(StatusArray1.length - 1, 1); // DELETE LAST INDEX ARRAY
						let updatedForm2 = { Stages: this.Stages, Status: secondLastIndexStatus, LTC:'' }
						db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update(updatedForm2);
					} else {
						db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({LTC:''});
					}
				}
			},
			// ALLOW ONLY LETTERS, DIGITS AND WHITE SPACE
			isCheckPostalCode(e) {
				var value =  e.target.value;
				if (!e.key.match(/[a-zA-Z0-9 ]/) || (e.key == ' ' && value[value.length-1] == ' ')) {
					e.preventDefault();  
				}
			},
			// TASK HIGH LIGHTED IF THEY ARE NEAR BY 3 DAYS
			HighLightNearByLast3DayTasks(task)
			{
				if(task.Status == 'draft' && (task.DueOn <= Date.now())){
					return 'text-left position-relative table-danger';
				} else if (task.DueOn <= new Date().setDate(new Date().getDate() + 3)) {
					return 'text-left position-relative table-warning';
				} else {
					return 'text-left position-relative';
				}
			},
			getExistingFolders() {
				let abc = [];
				this.prospect.Tags.forEach(element => {
					abc.push({key:element,value:element})
				});
				return abc
			},
			getConvertedText(text) {
				var urlRegex = /(https?:\/\/[^\s]+)/g;
				return text.replace(urlRegex, function(url) {
					return '<a href="' + url + '"'+'target="_blank"'+'>' + url + '</a>';
				});
			},
			getConvertedText1(text) {
				var a = text.description;
				var urlRegex = /(https?:\/\/[^\s]+)/g;
				return a.replace(urlRegex, function(url) {
					return '<a href="' + url + '"'+'target="_blank"'+'>' + url + '</a>';
				});
			},
			convertUTCDateTime(date){    
				return new Date(date.getTime() + (new Date().getTimezoneOffset() * 60000));
			},
			convertToLocalDateTime(date){
				// return new Date(date.getTime() - (new Date().getTimezoneOffset() * 60000));
				return date.getTime() - (new Date().getTimezoneOffset() * 60000);
			},
			formatNote(datetime) {
				let note = this.prospect.Notes[datetime];
				return datetime == this.focusedNote ? note : note.length > 140 ? note.substring(0, 140) + ' <a href="javascript:void(0)" class="TextDecorationNone">Click To Expand</a> ' : note;
			},
			formatNote1(datetime) {
				var ee = [];
				ee = Object.assign(ee,this.prospect.Notes);
				if(ee.length) {
					ee.sort((a, b) => b.date - a.date);
				}
				let note = ee[datetime].description;
				return datetime == this.focusedNote ? note : note.length > 140 ? note.substring(0, 140) + ' <a href="javascript:void(0)" class="TextDecorationNone">Click To Expand</a> ' : note;
			},
			toggleTag(Folder) {
				//eslint-disable-next-line
				console.log(Folder);
			},
			toggleEdit() {
				//eslint-disable-next-line
				console.log("edit click");
				if (this.edit) {
					// this.saveDataOnChange();
					this.save();
				}
				this.edit = true;
				// if (this.edit) {
				// 	this.save();
				// } else {
				// 	this.edit = true;
				// }
			},
			toggleEditForScreening() {
				if(this.editScreening){
					this.editScreening = false;
				}else{
					this.editScreening = true;
				}
			},
			toggleEditForScreeningSave(){
				if(this.editScreening){
					let updateForm = {};
					this.screenCriteriaDrpdwn.forEach(item => {
						updateForm[`screenCriteria.${item.key}`] = item.value;
					});
					updateForm['screenCriteria.dateUpdated'] = Date.now();
					updateForm['screenCriteria.updatedAuthor'] = "User";
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update(updateForm);
				}
				this.editScreening = false;
				this.screenCriteriaDrpdwn=[];
			},
			toggleShare() {
				this.$bvModal.show('toggleShare')
				getSubUserList({
					UID: this.user.id,
				})
				.then((res) => this.dropdDownData(res))
				.catch(err => alert(`Failure getting sub user list: ${err}`));
			},
			dropdDownData(res) {
				this.options = [];
				if (res.data.length) {
					for (let su of res.data) {
						this.options.push({
							value:su.id,
							text:su.First +' '+ su.Last
						});
					}
					this.isShareClick = true;
				}else {
					alert('Sub user not found to share prospects');
				}
			},
			
			onSubUserChange() {
				let data = this.options.find(op => op.value == this.selectedSubUser)
				this.selectedSubUserName = data.text;
			},
			saveSharedProspect() {
				if (this.selectedSubUser) {
					this.isSharing = true;
					shareProspect({
						UID:this.user.id,
						PID:this.prospect.id,
						Number:this.prospect.Number,
						subUID:this.selectedSubUser,
						subUName:this.selectedSubUserName,
						masterUName:this.user.First +' '+ this.user.Last,
						UserId:this.user.Uid
					})
					.then((res) => this.showMsg(res))
					.catch(err => alert(`Failure while saving popup: ${err}`));
				}else {
					alert('Please select user to share');
				}
			},
			showMsg(res) {
				this.isSharing = false;
				alert(res.data);
			},
			commonCreateNotes(notesAdd) {
				var clr = this.setDefaultNotesColor;
				if(this.colorSelected && this.colorSelected != null && this.colorSelected.value) {
					clr = this.colorSelected.value;
				}
				var notesArray1 = [];
				var nt = [];
                Object.assign(nt,this.prospect.Notes) ;
				if(this.prospect.hasOwnProperty('Notes') && nt != null || nt != undefined) {
					notesArray1 = nt;
				}
				let notesArray2 = [{
					'date': Date.now(),
					'description': notesAdd,
					'mediaURL': this.uplodedFilePathNotes,
					'color': clr
				}];
				let notesFinalArray = [...notesArray1, ...notesArray2];
				db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({ Notes: notesFinalArray })
				.catch(err => {
					this.$emit('error', err);
				});
				this.note = '';
				this.uplodedFilePathNotes = '';
				this.hideDivNotes = false;
				this.colorSelected = null;
				document.getElementsByClassName("customDropWithImg")[0].style.backgroundColor = this.setDefaultNotesColor;
			},
			addNote(event) {
				if (event.shiftKey) {
					this.note += '\n';
					return;
				}
				if (this.note == "") {
					return;
				}
				this.commonCreateNotes(this.note);
				/*if (this.prospect.Notes) {
					this.$set(this.prospect.Notes, Date.now(), this.note);
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({ Notes: this.prospect.Notes })
					.catch(err => {
						this.$emit('error', err);
					});
				} else {
					//eslint-disable-next-line
					console.log('ELSE');
					let firstNote = {};
					this.$set(firstNote, Date.now(), this.note);
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({ Notes: firstNote })
					.catch(err => {
						this.$emit('error', err);
					});
				}*/
			},
			addTask(event) {
				if (event.shiftKey) {
					this.taskName += '\n';
					return;
				}
				if (this.taskName == "") {
					this.isValidTask = false;
					return;
				}
				if (this.taskName == '' || this.form.date == '') {
					this.isValidTask = false;
					return
				}
				this.$emit('showLoader', true);
				// var date = new Date(this.form.date+' '+ this.form.time);
				// var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
				let now_utc = new Date(`${this.form.date} ${this.form.time}`).valueOf();
				if (this.form.time == '') {
					now_utc = now_utc + (3600000*9)
				}
				const taskData = {
					pid:this.user.id,
					cid:this.prospect.id,
					taskName:this.taskName,
					// dueDate:this.form.date+' '+ this.form.time,
					dueDate:now_utc,
				};
				axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/createTask", taskData)
				.then(response => {
					this.$emit('showLoader', false);
						// eslint-disable-next-line
					console.log(response)
					this.taskName = "";
					this.form.date = '';
					this.form.time = '';
					alert("New Task Added Successfully");
				});
				// let ms = new Date(`${this.form.date} ${this.form.time}`).valueOf();
				// let newTask = [];
				// if (this.prospect.Tasks) {
				// 	// this.$set(this.prospect.Notes, Date.now(), this.note);
				// 	newTask = this.prospect.Tasks;
				// 	newTask.push({'CreatedOn':Date.now(),'CompletedOn':'','DueOn':ms,'Description':this.taskName,'Status':'draft'}); 
				// 	db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({ Tasks: newTask })
				// 	.catch(err => {
				// 		this.$emit('error', err);
				// 	});
				// } else {
				// 	// this.$set(firstNote, Date.now(), this.note);
				// 	newTask.push({'CreatedOn':Date.now(),'CompletedOn':'','DueOn':ms,'Description':this.taskName,'Status':'draft'});
				// 	db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({ Tasks: newTask })
				// 	.catch(err => {
				// 		this.$emit('error', err);
				// 	});
				// }
				// this.taskName = "";
				// this.form.date = '';
				// this.form.time = '';
			},
			async save() {
				if (!this.prospect) {
					if (!this.optIn) {
						alert("Prospect cannot be added unless express permission is given");
						return;
					}
					let formattedNum = this.form.Number;
					this.form.Number = this.$parseNumber(this.form.Number);
					if (this.prospects.find(prosp => prosp.Number == this.form.Number)) {
						this.form.Number = formattedNum;
						alert("A prospect with this number already exists");
						return;
					}
					if(this.form.Number) {
						await getPhoneData({Number:this.form.Number})
						.then((res) => this.showPhoneData(res))
						.catch(err => this.showPhoneError(err));
					}
					db.collection(`Users/${this.user.id}/Prospects`).add({
						...this.form,
						DateCreated: Date.now()
					})
					.then((prosp) => {
						this.edit = false;
						this.optIn = false;
						this.$store.commit('globals/SET', { var: 'activeProsp', val: prosp.id });
					})
					.catch(err => {
						this.form.Number = formattedNum;
						this.$emit('error', err);
					})
				} else {
					if (this.prospect.Number) {
						await getPhoneData({Number:this.prospect.Number})
						.then((res) => this.showPhoneData(res))
						.catch(err => this.showPhoneError(err));
					}
					let formattedNum = this.form.Number;
					this.form.Number = this.$parseNumber(this.form.Number);
					if (this.prospect.Number !== this.form.Number) {
						updateProspectNumber({
							beforeNumber:this.prospect.Number,
							afterNumber:this.form.Number,
							Uid:this.user.Uid
						})
						.then(() => {
							this.edit = false;
						})
						.catch(err => {
							alert(`Error In Updating Phone Number in Other Collection : ${err}`)
						});
					}
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update(this.form)
					.then(() => {
						this.edit = false;
					})
					.catch(err => {
						this.$emit('error', err);
					})
					.finally(() => {
						this.form.Number = formattedNum;
					});
				}
			},
			async savePhoneOnChange() {
				// this.save();
				let prospeNumber = this.prospect.Number ? this.prospect.Number : '';
				let formattedNum = this.form.Number;
				this.form.Number = this.$parseNumber(this.form.Number);
				if (this.prospect) {
					if (this.prospects.find(prosp => prosp.Number == this.form.Number)) {
						this.form.Number = formattedNum;
						alert("A prospect with this number already exists");
						return;
					}
					await getPhoneData({Number:this.form.Number})
					.then((res) => this.showPhoneData(res))
					.catch(err => this.showPhoneError(err));

					if (this.prospect.Number !== this.form.Number) {
						updateProspectNumber({
							beforeNumber:this.prospect.Number,
							afterNumber:this.form.Number,
							Uid:this.user.Uid
						})
						.then(() => {
							// this.edit = false;
						})
						.catch(err => {
							alert(`Error In Updating Phone Number in Other Collection : ${err}`)
						});
					}

					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update(this.form)
					.then(async() => {
						// this.edit = false;
						this.form.Number = this.$parseNumber(this.form.Number);
						let convo = this.convos.find(convo => convo.ClientNumber == this.form.Number);
						if ((typeof convo === 'undefined' || convo === undefined) && (prospeNumber == '')) {
							let passData = {
								AgentNumber: this.user.Twilio,
								ClientNumber: this.form.Number,
								Uid: this.user.Uid
							};
							await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/addConvoOnceNumberValidate", passData)
							.then(response => {
								//eslint-disable-next-line
								console.log("Response: ", response);
								setTimeout(() => {
									this.form.Number = this.$parseNumber(this.form.Number);
									let convo1 = this.convos.find(convo => convo.ClientNumber == this.form.Number);
									this.$store.commit('globals/SET', { var: 'activeProsp', val: this.prospect.id });
									this.$store.commit('globals/SET', { var: 'activeConvo', val: convo1.id });
									this.$store.dispatch('firebase/bindMessages', convo1.id);
								}, 100);
							}).catch(err => alert(`Something wrong in data: ${err}`));
						} else {
							//eslint-disable-next-line
							console.log("convo already created there.");
						}

					})
					.catch(err => {
						this.$emit('error', err);
					})
					.finally(() => {
						this.form.Number = formattedNum;
					});
				}
			},
			async changeStatusinsertTheNewTask(passStatus) {
				if(this.user.hasOwnProperty('stageSettings')) {
					let  getLateststageSettingsArray = [];
					getLateststageSettingsArray = this.user.stageSettings.filter(rp => rp.name == passStatus);
					for(var k=0; k < getLateststageSettingsArray.length;) {
						await this.insertTheNewTask(getLateststageSettingsArray, k);
						k++;
					}
				}
			},
			async insertTheNewTask(getLateststageSettingsArray, k) {
				let nowUTC = new Date().valueOf(); // CURRENT DATE/TIME
				let nowUTCAdded = nowUTC + (getLateststageSettingsArray[k]['due'] * (24 * 60 * 60 * 1000))
				const taskData = {
					pid : this.user.id,
					cid : this.prospect.id,
					taskName : getLateststageSettingsArray[k]['desc'],
					dueDate : nowUTCAdded,
				};
				await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/createTask", taskData)
				.then(response => {
					//eslint-disable-next-line
					console.log("New Task Added Successfully", response);
				});
			},
			StatusDataOnChange() {
				// CREATE NEW TASK DURING STATUS CHANGE
				this.changeStatusinsertTheNewTask(this.form.Status);

				var StatusArray1 = [];
				if(this.Stages != null || this.Stages != undefined) {
					StatusArray1 = this.Stages;
				}
				let StatusArray2 = [{Date:new Date().valueOf(), Stage:this.form.Status}];
				let StatusArrayFinalOutput = [...StatusArray1, ...StatusArray2];
				let updatedForm = { Stages: StatusArrayFinalOutput, Status:this.form.Status }
				db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update(updatedForm);
			},
			CompetitorNameDataOnChange() {
				let updatedForm = { CompetitorName: this.form.CompetitorName }
				db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update(updatedForm);
			},
			saveDataOnChange() {
				if (!this.prospect) {
					if (!this.optIn) {
						alert("Prospect cannot be added unless express permission is given");
						return;
					}
					let formattedNum = this.form.Number;
					this.form.Number = this.$parseNumber(this.form.Number);

					if(this.user.Version && this.user.Version == 2) 
					{
						// INTERVIEWED
						if(this.Interviewed != '') {
							// this.form.Interviewed = Interviewed + (3600000*9);
							let Interviewed = new Date(`${this.Interviewed} ${this.form.InterviewTime}`).valueOf();
							this.form.Interviewed = Interviewed;
						} else {
							this.form.Interviewed = '';
						}

						// HIRED
						if(this.Hired != '') {
							let Hired = new Date(`${this.Hired}`).valueOf();
							this.form.Hired = Hired + (3600000*9);
						} else {
							this.form.Hired = '';
						}

						// LTC
						if(this.LTC != '') {
							let LTC = new Date(`${this.LTC}`).valueOf();
							this.form.LTC = LTC + (3600000*9);
						} else {
							this.form.LTC = '';
						}
					}

					db.collection(`Users/${this.user.id}/Prospects`).add({
						...this.form,
						DateCreated: Date.now()
					})
					.then((prosp) => {
						// this.edit = false;
						this.optIn = false;
						this.$store.commit('globals/SET', { var: 'activeProsp', val: prosp.id });
					})
					.catch(err => {
						this.form.Number = formattedNum;
						this.$emit('error', err);
					})
				}else {
					let formattedNum = this.form.Number;
					this.form.Number = this.$parseNumber(this.form.Number);

					if(this.user.Version && this.user.Version == 2) 
					{
						// INTERVIEWED
						if(this.Interviewed != '') {
							// this.form.Interviewed = Interviewed + (3600000*9);
							let Interviewed = new Date(`${this.Interviewed} ${this.form.InterviewTime}`).valueOf();
							this.form.Interviewed = Interviewed;
						} else {
							this.form.Interviewed = '';
						}

						// HIRED
						if(this.Hired != '') {
							let Hired = new Date(`${this.Hired}`).valueOf();
							this.form.Hired = Hired + (3600000*9);
						} else {
							this.form.Hired = '';
						}

						// LTC
						if(this.LTC != '') {
							let LTC = new Date(`${this.LTC}`).valueOf();
							this.form.LTC = LTC + (3600000*9);
						} else {
							this.form.LTC = '';
						}
					}

					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update(this.form)
					.then(() => {
						// this.edit = false;
					})
					.catch(err => {
						this.$emit('error', err);
					})
					.finally(() => {
						this.form.Number = formattedNum;
					});

				}
				this.edit = false;
			},
			showPhoneData(res) {
				let phoneData = JSON.parse(res.data);
				this.form.CarrierType = phoneData.carrier.type;
			},
			showPhoneError(err) {
				this.form.CarrierType = null;
				alert(`Not able to find prospect Number Type : `+ err)
			},
			removeNote(key) {
				if (confirm("Are you sure you want to delete this note?")) {
					this.$delete(this.prospect.Notes, key);
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update(this.prospect);
				}
			},
			removeNote1(key) {
				if (confirm("Are you sure you want to delete this note?")) {
					var w = this.prospect.Notes.find(s=>s.date == key.date);
					if(w) {
						this.prospect.Notes.splice(this.prospect.Notes.indexOf(w), 1);
						db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({ Notes: this.prospect.Notes })
					}
				}
			},
			removeTask(key) {
				if (confirm("Are you sure you want to delete this task?")) {
					let i=0;
					for (let t of this.prospect.Tasks) {
						if (key.CreatedOn == t.CreatedOn) {
							this.prospect.Tasks.splice(i,1)
						}
						i++;
					}
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Tasks:this.prospect.Tasks});
					const overdueProspects = this.prospects.filter(prospect => this.isOverDue(prospect));
					this.$store.commit('globals/SET', { var: 'dueTaskCountTotal', val: overdueProspects.length });
				}
			},
			compeleteTask(key) {
				if (confirm("Are you sure you want to mark this task as completed?")) {
					// let i=0;
					let taskDesc = '';
					for (let t of this.prospect.Tasks) {
						if (key.CreatedOn == t.CreatedOn) {
							// this.prospect.Tasks.splice(i,1)
							// t.Status = 'compeleted';
							t.Status = 'compeleted';
							// this.prospect.Tasks.splice(i,1)
							t.CompletedOn = Date.now();
							taskDesc = t.Description;
						}
						// i++;
					}
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Tasks:this.prospect.Tasks});
					let noteMsg = "Task "+ taskDesc + " was completed";
					this.commonCreateNotes(noteMsg);
					const overdueProspects = this.prospects.filter(prospect => this.isOverDue(prospect));
					this.$store.commit('globals/SET', { var: 'dueTaskCountTotal', val: overdueProspects.length });
					/*
					let noteList = this.prospect.Notes;
					let firstNote = {};
					if (!noteList) {
						firstNote[Date.now()] = noteMsg;
					} else if (Object.keys(noteList).length > 0) {
						noteList[Date.now()] = noteMsg;
						firstNote = noteList;
					} else {
						firstNote[Date.now()] = noteMsg;
					}
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Notes:firstNote});
					*/
				}
			},
			initForm() {
				if (this.prospect) {
					this.mailTo = 'mailto:'+this.prospect.Email;
					this.form.First = this.prospect.First ? this.prospect.First : '';
					this.form.Last = this.prospect.Last ? this.prospect.Last : '';
					this.form.Email = this.prospect.Email ? this.prospect.Email : '';
					this.form.Zip = this.prospect.Zip ? this.prospect.Zip : '';
					
					this.popupAddressStreet = this.prospect.StreetAddress ? this.prospect.StreetAddress : '';
					this.popupAddressState = this.prospect.State ? this.prospect.State : '';
					this.popupAddressCity = this.prospect.City ? this.prospect.City : '';
					this.popupAddressZip = this.prospect.Zip ? this.prospect.Zip : '';
					
					this.form.Status = this.prospect.Status ? this.prospect.Status : null;
					this.form.Tags = this.prospect.Tags ? this.prospect.Tags : null;
					this.form.Office = this.prospect.Office ? this.prospect.Office : null;
					this.Hired = this.prospect.Hired ? new Date(this.prospect.Hired) : '';
					this.LTC = this.prospect.LTC ? new Date(this.prospect.LTC) : '';
					this.Interviewed = this.prospect.Interviewed ? new Date(this.prospect.Interviewed) : '';
					this.Stages = this.prospect.Stages ? this.prospect.Stages : null;
					this.form.CompetitorName = this.prospect.CompetitorName ? this.prospect.CompetitorName : '';
					this.mform.SendGroup = this.prospect.SendGroup ? this.prospect.SendGroup : '';
					
					if(this.user.Version && this.user.Version == 2) {
						this.mform.Office = this.form.Office;
					}

					// this.InterviewNoShow = this.prospect.InterviewShow ? this.prospect.InterviewShow : '';
					this.InterviewedShowDate = this.prospect.InterviewShow ? new Date(this.prospect.InterviewShow) : '';
					
					this.form.InterviewScore = this.prospect.InterviewScore ? this.prospect.InterviewScore : null;

					if(this.InterviewedShowDate != '') {
						this.InterviewNoShow = true;
						this.InterviewedNoShowcheckBoxSelectedDisable = false;
						this.InterviewedShowDate = `${this.InterviewedShowDate.getFullYear()}-${this.InterviewedShowDate.getMonth()+1}-${this.InterviewedShowDate.getDate()}`;
					} else {
						this.InterviewNoShow = false;
						this.InterviewedNoShowcheckBoxSelectedDisable = true;
					}

					if(this.Interviewed != '') {
						this.InterviewedcheckBoxSelected = true;
						this.InterviewedcheckBoxSelectedDisable = false;
						// this.Interviewed = `${this.Interviewed.getFullYear()}-${this.Interviewed.getMonth()+1}-${this.Interviewed.getDate()}`;
						let date = new Date(this.Interviewed);
						// this.form.InterviewTime = `9:00:00`;
						this.Interviewed = `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`;
						// this.form.InterviewTime = `${date.getHours()}:${date.getMinutes()}:00`;
					} else {
						this.InterviewedcheckBoxSelected = false;
						this.InterviewedcheckBoxSelectedDisable = true;
						this.form.InterviewTime = '';
					}

					if(this.Hired != '') {
						this.HiredCheckBoxSelected = true;
						this.HiredcheckBoxSelectedDisable = false;
						this.Hired = `${this.Hired.getFullYear()}-${this.Hired.getMonth()+1}-${this.Hired.getDate()}`;
					} else {
						this.HiredCheckBoxSelected = false;
						this.HiredcheckBoxSelectedDisable = true;
					}

					if(this.LTC != '') {
						this.LosttoCompetitorCheckBoxSelected = true;
						this.LosttoCompetitorcheckBoxSelectedDisable = false;
						this.LTC = `${this.LTC.getFullYear()}-${this.LTC.getMonth()+1}-${this.LTC.getDate()}`;
					} else {
						this.LosttoCompetitorCheckBoxSelected = false;
						this.LosttoCompetitorcheckBoxSelectedDisable = true;
					}

					this.edit = false;
					this.editScreening = false;
				} else {
					this.form.First = '';
					this.form.Last = '';
					this.form.Email = '';
					this.form.Zip = '';
					this.form.Status = null;
					this.form.Tags = null;
					this.Stages = null;
					this.form.Office = '';
					this.Interviewed = '';
					this.Hired = '';
					this.LTC = '';
					this.form.CompetitorName = '';
					this.edit = true;
					this.editScreening = true;
					this.form.InterviewTime = '';
				}
				this.mform.SendGroup = this.user.SendGroup ? this.user.SendGroup : '';
				this.form.Number = this.$parseNumber(this.number);
			},
			checkSubUser() {
				let val = true;
				if (this.user.ReportingTo) {
					val = false;
				}
				return val;
			},
			addSelectedTask(t) {
				this.taskName = this.taskName + " " + t;
			},
			openModal() {
				this.mform.First = this.form.First,
				this.mform.Last = this.form.Last;
				this.mform.Email = this.form.Email;
				this.mform.Number = this.form.Number;
				this.mform.Zip = this.form.Zip;
				this.mform.remDate = this.getRemDate();
				this.mform.Notes = '';
				this.mform.MgrID = '';
				this.mform.CCMgrID = '';
				this.selectedCCValue=[];
				// this.$bvModal.show('SendTOManagerModal')
				this.$modal.show('SendTOManagerModal');
			},
			getRemDate() {
				let rDate = new Date();
				rDate.setDate(rDate.getDate() + 7);
				rDate = rDate.getFullYear()+"-"+(rDate.getMonth()+1)+"-"+rDate.getDate();
				return rDate;
			},
			async sendToManager() {
				const Mdata = this.user.Managers.filter(et => this.selectedCCValue.includes(et.First+' '+et.Last+'-'+et.Office));
				const [ccMgrID, ccMgrFirst, ccMgrLast,ccMgrEmail,ccMgrNumber,ccMgrOffice] = ['MgrID', 'First', 'Last','Email','Number','Office'].map(prop => Mdata.map(m => m[prop]));
				if (this.mform.MgrID) { 
					if (confirm("Are you sure you want to send this Prospect to the selected Manager?")) {
						let newManagerDetails = [];
						if (this.prospect.SentToManager) {
							newManagerDetails = this.prospect.SentToManager;
						}
						newManagerDetails.push({
							SentOn:Date.now(),
							ReviewedOn:'',
							Manager:this.mform.MgrID,
							CCManager:this.mform.CCMgrID,
							Rating:'',
							MgrNotes:'',
							Notes:this.mform.Notes,
							RemDate:new Date(`${this.mform.remDate}`).valueOf(),
						});
						//eslint-disable-next-line
						console.log("newManagerDetails", newManagerDetails);
						if (this.form.First != this.mform.First ||
							this.form.Last != this.mform.Last ||
							this.form.Email != this.mform.Email ||
							this.form.Number != this.mform.Number ||
							this.form.Zip != this.mform.Zip
							) {
								let updatedForm = {
									First:this.mform.First,
									Last:this.mform.Last,
									Email:this.mform.Email,
									Number:this.$parseNumber(this.mform.Number),
									Zip:this.mform.Zip
								}
								db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update(updatedForm);
						}
						let selectedManagerData = this.getManagerNameFromID(this.mform.MgrID);
						// let selectedCCManagerData = this.getManagerNameFromID(this.mform.CCMgrID);
						
						let selectedOfficeData;
						if(this.mform.Office) {
							selectedOfficeData = this.getOfficeNameFromID(this.mform.Office);
						}
						//eslint-disable-next-line
						console.log("selectedOfficeData", selectedOfficeData);
						
						sentManager({
							pFirst: this.mform.First,
							pLast:this.mform.Last,
							pEmail:this.mform.Email,
							pNumber:this.$parseNumber(this.mform.Number),
							pZip:this.mform.Zip,

							mFirst:selectedManagerData.First,
							mLast:selectedManagerData.Last,
							mEmail:selectedManagerData.Email,
							mNumber:selectedManagerData.Number,
							mOffice:selectedManagerData.Office,
							mId:selectedManagerData.MgrID,
							
							oname: selectedOfficeData ? selectedOfficeData.OfficeName : '',
							omanager: selectedOfficeData ? `${selectedOfficeData.MgrFirst} ${selectedOfficeData.MgrLast}` : '',
							ostreet: selectedOfficeData ? selectedOfficeData.StreetAddress : '',
							ocity: selectedOfficeData ? selectedOfficeData.City : '',
							ostate: selectedOfficeData ? selectedOfficeData.State : '',
							ozip: selectedOfficeData ? selectedOfficeData.ZipCode : '',

							// ccmFirst:selectedCCManagerData.First,
							// ccmLast:selectedCCManagerData.Last,
							// ccmEmail:selectedCCManagerData.Email,
							// ccmNumber:selectedCCManagerData.Number,
							// ccmOffice:selectedCCManagerData.Office,
							// ccmId:selectedCCManagerData.MgrID,

							ccmFirst:ccMgrFirst,
							ccmLast:ccMgrLast,
							ccmEmail:ccMgrEmail,
							ccmNumber:ccMgrNumber,
							ccmOffice:ccMgrOffice,
							ccmId:ccMgrID,

							Notes:this.mform.Notes,
							remDate:this.mform.remDate,

							pid:this.user.id,
							uFirst:this.user.First,
							uLast:this.user.Last,
							uEmail:this.user.Email,
							uNumber:this.user.Number,
							uTwilio:this.user.Twilio,
							uCompany:this.user.Company,

							// If CciMap have the ccimap data want to send to manager
							...(this.prospect.CciMap && {
							Banker:this.prospect.CciMap.Banker,
							Builder:this.prospect.CciMap.Builder,
							Cognitive:this.prospect.CciMap.Cognitive,
							Community:this.prospect.CciMap.Community,
							Creative:this.prospect.CciMap.Creative,
							Independent:this.prospect.CciMap.Independent,
							Innovator:this.prospect.CciMap.Innovator,
							Intuitive:this.prospect.CciMap.Intuitive,
							Merchant:this.prospect.CciMap.Merchant,
							Practical:this.prospect.CciMap.Practical,
							Priority:this.prospect.CciMap.Priority,
							ProfileId:this.prospect.CciMap.ProfileId,
							ProfileName:this.prospect.CciMap.ProfileName,
							Scorecard:this.prospect.CciMap.Scorecard,
							SnapshotName:this.prospect.CciMap.SnapshotName,
							DateSubmitted:this.prospect.CciMap.DateSubmitted,
							})
						})
						.then((data) => {
							//eslint-disable-next-line
							console.log(data);
						})
						.catch(err => alert(`Failure scheduling message: ${err.response.data.message}`));
						db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({SentToManager:newManagerDetails});
						let noteMsg = "Prospect was sent to " +selectedManagerData.First+" "+selectedManagerData.Last+ " for review.";
						this.commonCreateNotes(noteMsg);
						/*
						let noteList = this.prospect.Notes;
						let firstNote = {};
						if (!noteList) {
							firstNote[Date.now()] = noteMsg;
						} else if (Object.keys(noteList).length > 0) {
							noteList[Date.now()] = noteMsg;
							firstNote = noteList;
						} else {
							firstNote[Date.now()] = noteMsg;
						}
						db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Notes:firstNote});
						*/
						// this.$bvModal.hide('SendTOManagerModal');
						this.$modal.hide('SendTOManagerModal');
					}
				}else {
					alert("A Manager must be selected in order to send prospect information.");
				}
			},
			getManagerNameFromID(id) {
				if (id) {
					let data = this.user.Managers.find(m => m.MgrID == id)
					return data;
				}
				return ''
			},
			getOfficeNameFromID(id) {
				if (id) {
					let data = this.user.Offices.find(m => m.OfficeId == id)
					return data;
				}
				return ''
			},
			manageGoogleapisLatLng(getdata, response, i, currentCountryCode)
			{
				for(var j=0; j<getdata.length; j++) {
					if(getdata[j].types[0]=='country') {
					// if(getdata[j].types.indexOf('country') <= -1) {
						if(getdata[j].short_name == currentCountryCode) {
							this.googlelat = response.data.results[i].geometry.location.lat;
							this.googlelng = response.data.results[i].geometry.location.lng;
							this.countryCodeSet = 1;
						}
					}
				}
			},
			// DISPLAY THE CITY NAME, STATE NAME, COUNTRY NAME ACCORDING TO ZIP CODE - GOOGLE MAP APIs
			displayCountryStateCityName(response, i) {
				for(let m=0; m<response.data.results[i].address_components.length; m++) {
					if(response.data.results[i].address_components[m].types[0]=='administrative_area_level_1') {
						this.displayStateName = response.data.results[i].address_components[m].short_name;
					}
					if(response.data.results[i].address_components[m].types[0]=='locality') {
						this.displayCityName = response.data.results[i].address_components[m].short_name;
					}
					if(!this.displayCityName) {
						if(response.data.results[i].hasOwnProperty('postcode_localities') && response.data.results[i].postcode_localities.length) {
							this.displayCityName = response.data.results[i].postcode_localities.slice(-1)[0];
						}
					}
				}
			},
			async getProspectAddressZipcodeDetails() {
                var mergeAddress = this.prospect.Zip;
				var ConvertmergeAddress;
				if (/\s/.test(mergeAddress)) {
					ConvertmergeAddress = mergeAddress.replace(/\s+/g, '+'); // CONVERT WHITE SPACE TO PLUS
				} else {
					ConvertmergeAddress = mergeAddress;
				}
                // var ConvertmergeAddress = mergeAddress.replace(/\s+/g, '+'); // CONVERT WHITE SPACE TO PLUS
                await axios.get("https://maps.googleapis.com/maps/api/geocode/json?address="+ConvertmergeAddress+"&key=AIzaSyDB3iBxxzF9leRLy4mihVjBCAwWFenuuuA")
				.then(response => {
					this.displayStateName = '';
					this.displayCityName = '';
					//eslint-disable-next-line
					// console.log('getProspectAddressZipcodeDetails:', response);
					if(response.status == 200 && response.hasOwnProperty('data') && Object.keys(response.data.results).length) {
						let results = response.data.results;
						let isFound = 0;
						// var checkresultlength;
						for (let i = 0; i < results.length; i++) {
							for (let j = 0; j < results[i].address_components.length; j++) {
								if (results[i].address_components[j].types[0]=='country') {
									if (results[i].address_components[j].short_name == 'US') {
										isFound = 1;
										this.googlelat = response.data.results[i].geometry.location.lat;
										this.googlelng = response.data.results[i].geometry.location.lng;
										// if(results.length == 1) { checkresultlength = 0; } else { checkresultlength = 1; }
										this.displayCountryStateCityName(response, i);
										break;
									} else if (results[i].address_components[j].short_name == 'CA') {
										isFound = 2;
										this.googlelat = response.data.results[i].geometry.location.lat;
										this.googlelng = response.data.results[i].geometry.location.lng;
										// if(results.length == 1) { checkresultlength = 0; } else { checkresultlength = 1; }
										this.displayCountryStateCityName(response, i);
										break;
									}
								}
							}
						}
						if (isFound == 0) {
							this.googlelat = response.data.results[0].geometry.location.lat;
							this.googlelng = response.data.results[0].geometry.location.lng;
							this.displayCountryStateCityName(response, 0);
						}
						// for(var a=0; a<this.APICountryCode.length; a++) {
							// if(a<=1) {
							// 	if(this.countryCodeSet == 0) {
							// 		for(var i=0; i<response.data.results.length;i++) {
							// 			this.manageGoogleapisLatLng(response.data.results[i].address_components, response, i, this.APICountryCode[a]);
							// 		}
							// 	}
							// }
							// if(a==2) {
							// 	if(this.countryCodeSet == 0) {
							// 		this.googlelat = response.data.results[0].geometry.location.lat;
							// 		this.googlelng = response.data.results[0].geometry.location.lng;
							// 	}
							// }
						// }
					}

					//eslint-disable-next-line
					// console.log('this:', Object.keys(response.data.results).length);

					//eslint-disable-next-line
					// console.log('this.googlelat:', this.googlelat);
					//eslint-disable-next-line
					// console.log('this.googlelng:', this.googlelng);
					
					this.zipCodeDetails = response;
                });
            },
			getProspectZipcodeDetails : function() {
				axios.get("https://app.zipcodebase.com/api/v1/search?apikey=cdbfa120-2941-11ef-825e-45214465aa92&codes="+this.prospect.Zip+"&country=us")
				.then(response => {
					this.zipCodeDetails = response;
					
					// if (Object.keys(this.zipCodeDetails.data.results).length) {
						
					// 	if (this.user.Offices && this.user.Offices.length) {
							
					// 	}	
					// }
				});
			},
			/*openMapProspect() {
				if (Object.keys(this.zipCodeDetails).length && this.zipCodeDetails.hasOwnProperty('data') && Object.keys(this.zipCodeDetails.data.results).length) {
					this.coordinates = [this.zipCodeDetails.data.results[this.prospect.Zip][0].longitude,this.zipCodeDetails.data.results[this.prospect.Zip][0].latitude]
					this.$bvModal.show('ProspectMapModal');
					setTimeout(() => {
						this.bindMap();	
					}, 100);
					
				}else {
					alert('Prospect cannot be mapped without a Postal Code.');
				}
			},*/
			openMapProspect() {
				if (Object.keys(this.zipCodeDetails).length && this.zipCodeDetails.hasOwnProperty('data') && Object.keys(this.zipCodeDetails.data.results[0]).length) {
					// this.coordinates = [this.zipCodeDetails.data.results[0].geometry.location.lng,this.zipCodeDetails.data.results[0].geometry.location.lat]
					this.coordinates = [this.googlelng,this.googlelat]
					//eslint-disable-next-line
					// console.log('this.coordinates:', this.coordinates);
					this.$bvModal.show('ProspectMapModal');
					setTimeout(() => {
						this.bindMap();	
					}, 100);
					
				}else {
					alert('Prospect cannot be mapped without a Postal Code.');
				}
			},
			bindMap() {
				var map = new this.mapbox.Map({
					container: 'map', // container id
					style: 'mapbox://styles/mapbox/streets-v11', // style URL
					center: this.coordinates, // starting position [lng, lat]
					zoom: 9, // starting zoom
				})
				var nav = new this.mapbox.NavigationControl();
				map.addControl(nav, 'top-left');
				map.addControl(new this.mapbox.FullscreenControl());
				var scale = new this.mapbox.ScaleControl({
					maxWidth: 200,
					unit: 'imperial'
				});
				map.addControl(scale);
				scale.setUnit('imperial');

				new this.mapbox.Marker({anchor: "center",color: "blue"})
				.setLngLat(this.coordinates)
				.setPopup(new this.mapbox.Popup()
				.setHTML(this.prospect.First+' '+this.prospect.Last)).addTo(map);
				this.user.Offices.forEach(element => {
					//if (this.prospect.Zip != element.ZipCode) {
						new this.mapbox.Marker({anchor: "center", color: "gray"})
						.setLngLat([element.longitude,element.latitude])
						.setPopup(new this.mapbox.Popup().setHTML(element.OfficeName))
						.addTo(map);
					//}
				});

				var distanceContainer = document.getElementById('distance');

				var geojson = {
					'type': 'FeatureCollection',
					'features': []
				};

				var linestring = {
					'type': 'Feature',
					'geometry': {
						'type': 'LineString',
						'coordinates': []
					}
				};

				map.on('load', function () {
				map.addSource('geojson', {'type': 'geojson','data': geojson});	
				map.addLayer({
					id: 'measure-points',
					type: 'circle',
					source: 'geojson',
					paint: {
						'circle-radius': 5,
						'circle-color': '#000'
					},
					filter: ['in', '$type', 'Point']
				});

				map.addLayer({
					id: 'measure-lines',
					type: 'line',
					source: 'geojson',
					layout: {
						'line-cap': 'round',
						'line-join': 'round'
					},
					paint: {
						'line-color': '#000',
						'line-width': 2.5
					},
					filter: ['in', '$type', 'LineString']
				});

				map.on('click', function (e) {
					var features = map.queryRenderedFeatures(e.point, {
						layers: ['measure-points']
					});

					// Remove the linestring from the group
					// So we can redraw it based on the points collection
					if (geojson.features.length > 1) geojson.features.pop();

					// Clear the Distance container to populate it with a new value
					distanceContainer.innerHTML = '';

					// If a feature was clicked, remove it from the map
					if (features.length) {
						var id = features[0].properties.id;
						geojson.features = geojson.features.filter(function (point) {
							return point.properties.id !== id;
						});
					} else {
						var point = {
							'type': 'Feature',
							'geometry': {
								'type': 'Point',
								'coordinates': [e.lngLat.lng, e.lngLat.lat]
							},
							'properties': {
								'id': String(new Date().getTime())
							}
						};
						geojson.features.push(point);
					}
					if (geojson.features.length > 1) {
						linestring.geometry.coordinates = geojson.features.map(
						function (point) {
							return point.geometry.coordinates;
						});

						geojson.features.push(linestring);

						// Populate the distanceContainer with total distance
						var value = document.createElement('pre');
						value.textContent = 'Total distance: ' + turf.length(linestring).toLocaleString() + ' mi';
						distanceContainer.appendChild(value);
					}
					map.getSource('geojson').setData(geojson);
				});

					map.on('mousemove', function (e) {
						var features = map.queryRenderedFeatures(e.point, {
							layers: ['measure-points']
						});
						// UI indicator for clicking/hovering a point on the map
						map.getCanvas().style.cursor = features.length
							? 'pointer'
							: 'crosshair';
					});
			});		
			},
				
			async onMapLoaded(event) {
				
				// in component
				// this.map = event.map;
				// or just to store if you want have access from other components
				// this.$store.map = event.map;
				// Here we cathing 'load' map event
				event.map.resize();
				// event.map.addSource('geojson', {
				// 	'type': 'geojson',
				// 	'data': this.geojson
				// });


				// event.map.addLayer({
				// 	id: 'measure-points',
				// 	type: 'circle',
				// 	source: 'geojson',
				// 	paint: {
				// 		'circle-radius': 5,
				// 		'circle-color': '#000'
				// 	},
				// 	filter: ['in', '$type', 'Point']
				// });
				// event.map.addLayer({
				// 	id: 'measure-lines',
				// 	type: 'line',
				// 	source: 'geojson',
				// 	layout: {
				// 		'line-cap': 'round',
				// 		'line-join': 'round'
				// 	},
				// 	paint: {
				// 		'line-color': '#000',
				// 		'line-width': 2.5
				// 	},
				// 	filter: ['in', '$type', 'LineString']
				// });
				
				// event.map.on('click', function (e) {
					
				// 	var features = event.map.queryRenderedFeatures(e.point, {
				// 		layers: ['measure-points']
				// 	});
				// 	//eslint-disable-next-line
				// 	console.log(features);
				// 	// Remove the linestring from the group
				// 	// So we can redraw it based on the points collection
				// 	// if (this.geojson.features.length > 1) this.geojson.features.pop();

				// 	// Clear the Distance container to populate it with a new value
				// 	// distanceContainer.innerHTML = '';

				// 	// If a feature was clicked, remove it from the map
				// 	if (features.length) {
				// 		var id = features[0].properties.id;
				// 		this.geojson.features = this.geojson.features.filter(function (point) {
				// 			return point.properties.id !== id;
				// 		});
				// 	} else {
				// 		var point = {
				// 			'type': 'Feature',
				// 			'geometry': {
				// 				'type': 'Point',
				// 				'coordinates': [e.lngLat.lng, e.lngLat.lat]
				// 			},
				// 			'properties': {
				// 				'id': String(new Date().getTime())
				// 			}
				// 		};

				// 		this.geojson.features.push(point);
				// 	}

				// 	if (this.geojson.features.length > 1) {
				// 		this.linestring.geometry.coordinates = this.geojson.features.map(
				// 			function (point) {
				// 				return point.geometry.coordinates;
				// 			}
				// 		);

				// 		this.geojson.features.push(this.linestring);

				// 		// Populate the distanceContainer with total distance
				// 		var value = document.createElement('pre');
				// 		// value.textContent =
				// 		// 	'Total distance: ' +
				// 		// 	turf.length(this.linestring).toLocaleString() +
				// 		// 	'mi';
						
				// 		//eslint-disable-next-line
				// 		console.log(value);
				// 		// distanceContainer.appendChild(value);
				// 	}

				// 	event.map.getSource('geojson').setData(this.geojson);
				// 	event.map.on('mousemove', function (e) {
				// 		var features = event.map.queryRenderedFeatures(e.point, {
				// 			layers: ['measure-points']
				// 		});
				// 		// UI indicator for clicking/hovering a point on the map
				// 		event.map.getCanvas().style.cursor = features.length
				// 			? 'pointer'
				// 			: 'crosshair';
				// 	});
				// });
				const asyncActions = event.component.actions
				
				await asyncActions.flyTo({
					// center: [this.zipCodeDetails.data.results[this.prospect.Zip][0].longitude,this.zipCodeDetails.data.results[this.prospect.Zip][0].latitude],
					center: [this.zipCodeDetails.data.results[0].geometry.location.lng,this.zipCodeDetails.data.results[0].geometry.location.lat],
					zoom: 8,
					speed: 1,
				});
			},
			onJsonLayerClick(event) {
				var features = event.map.queryRenderedFeatures(event.mapboxEvent.point, {
					layers: ['points']
				});
				if (this.geoJsonSource.data.features.length > 1) this.geoJsonSource.data.features.pop();
				//eslint-disable-next-line
				console.log(features);
			},
			onJsonLayerMove() {
				
			},
			onAddTag(slug) {
				let fd = this.user.Folders;
				if (fd.indexOf(slug.value) < 0) {
					fd.push(slug.value);
					db.doc(`Users/${this.user.id}`).update({Folders:fd});
				}
				this.selectedTags = [];
				this.updateTags(slug.value);
			},
			// onInitialized() {
			// 	this.selectedTags = [];
			// 	this.prospect.Tags.forEach(element => {
			// 		this.selectedTags.push({key:element,value:element})
			// 	});
			// },
			updateTags(value) {
				let tagsArray = [];
				if (this.prospect.Tags.indexOf(value) < 0) {
					tagsArray = this.prospect.Tags;
					tagsArray.push(value);
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({ Tags: tagsArray });
					// this.onInitialized();
				}
			},
			removeTag(tagval) {
				
				let i = this.prospect.Tags.indexOf(tagval);
				this.prospect.Tags.splice(i,1);
				let tagsArray = [];
				tagsArray = this.prospect.Tags;
				db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({ Tags: tagsArray });
			}
			
		},
		watch: {
			note: {
				/* this handler controls the growth of the input text-area */
				handler() {
					setTimeout(() => {
						this.$refs.input.rows = 1;
						while (this.$refs.input.scrollHeight > this.$refs.input.offsetHeight && this.$refs.input.rows < 4) {
							this.$refs.input.rows += 1;
						}
					})
				}
			},
			prospect: {
				immediate: true,
				handler() {
					this.initForm();
					this.mapbox = Mapbox;
					this.mapbox.accessToken  = this.accessToken;
					this.zipCodeDetails = {}
					if (this.prospect && this.prospect.Zip) {
						// this.getProspectZipcodeDetails();
						this.getProspectAddressZipcodeDetails();
					}
				}
			}
		},
		data() {
			return {
				tempDataForDropdown:null,
				screenCriteriaDrpdwn:[],
				editScreening:false,
				clickedNote: null,
				setTypeaHead:false,
				InterviewScoreOptions: [
					{ value: null, text: 'Please Select Interview Score' },
					{ value: 1, text: 'Excellent' },
					{ value: 2, text: 'Good' },
					{ value: 3, text: 'Fair' },
					{ value: 4, text: 'Poor' }
				],
				
				reminderBtnStatus: false,
				reminderBtnStatusCount: 0,
				popupAddressStreet: '',
				popupAddressCity: '',
				popupAddressState: '',
				popupAddressZip: '',

				displayCountryName:'',
				displayStateName:'',
				displayCityName:'',
				countryCodeSet:0,
				APICountryCode:['US', 'CA', 'Default'],
				googlelat:'',
				googlelng:'',
				InterviewedcheckBoxSelectedDisable: true,
				InterviewedNoShowcheckBoxSelectedDisable: true,
				HiredcheckBoxSelectedDisable: true,
				LosttoCompetitorcheckBoxSelectedDisable: true,
				InterviewedcheckBoxSelected: false,
				HiredCheckBoxSelected: false,
				LosttoCompetitorCheckBoxSelected: false,
				selectedTags: [],
				Stages: [],
				focusedNote: '',
				optIn: false,
				edit: false,
				isShareClick:false,
				isSharing:false,
				selectedSubUser:'',
				selectedSubUserName:'',
				options: [],
				note: "",
				Interviewed:'',
				Hired:'',
				InterviewedShowDate: '',
				LTC:'',
				hDate:'',
				InterviewNoShow: false,
				form: {
					// InterviewTime: "9:00:00",
					InterviewTime: "",
					Number: '', // Here bc mask doesn't work otherwise
					date:'',
					time:'',
					Office:null,
					Interviewed:0,
					InterviewScore:null,
					Hired:0,
					LTC:0,
					hDate:0,
				},
				mform : {
					First:'',
					Last:'',
					Number:'',
					Email:'',
					Zip:'',
					Notes:'',
					remDate:'',
					MgrID:'',
					CCMgrID:'',
					SendGroup:'',
					Office:'',
				},
				mailTo:'',
				taskName:'',
				isValidTask:true,
				accessToken: 'pk.eyJ1IjoibG9nYW5keml1ayIsImEiOiJja3BkZDJwNmcwMGgzMm5sZW5zemRhNjJlIn0.ulgQW-9KuvSNHB5IsW3IjQ',
				mapStyle:'mapbox://styles/mapbox/streets-v11',
				coordinates: [],
				zipCodeDetails:{},
				geoJsonSource: {
					type: "geojson",
					data: {
						id: "points",
						type: "FeatureCollection",
						features: []
					}
				},
				geoJsonLayer: {
					id: "points",
					type: "circle",
					paint: {
					'circle-radius': 5,
					'circle-color': '#000'
					},
					filter: ['in', '$type', 'Point']
				},
				geoJsonSource2: {
					type: "geojson",
					data: {
						id: "points2",
						type: "FeatureCollection",
						features: []
					}
				},
				geoJsonLayer2: {
					id: "points2",
					type: "line",
					layout: {
						'line-cap': 'round',
						'line-join': 'round'
					},
					paint: {
						'line-color': '#000',
						'line-width': 2.5
					},
					filter: ['in', '$type', 'LineString']
				},
				fileDataNotes: null,
				hideDivNotes:false,
				uploadValueNotes: 0,
				uplodedFilePathNotes:'',
				imageFormatArrayNotes:['jpg','jpeg','png','gif','bmp'],
				audioFormatArrayNotes:['basic','L24','mpeg','ogg','vorbis','vnd.rn-realaudio','vnd.wave','3gpp','3gpp2','ac3','vnd.wave','amr-nb','amr'],
				videoFormatArrayNotes:['webm','mpeg','mp4','3gpp','quicktime','3gpp2','3gpp-tt','H261','H263','H263-1998','H263-2000','H264','mp3'],
				documentFormatArrayNotes:['pdf','vcard','csv','rtf','richtext','calendar','directory','pptx','doc','docx'],
				supportedTypeNotes: ['audio/basic','audio/L24','audio/mp4','audio/mpeg3','audio/mp3','audio/mpeg','audio/ogg','audio/vorbis','audio/vnd.rn-realaudio','audio/vnd.wave','audio/3gpp','audio/3gpp2','audio/ac3','audio/vnd.wave','audio/webm','audio/amr-nb','audio/amr',
				'video/mpeg','video/mp4','video/quicktime','video/webm','video/3gpp','video/3gpp2','video/3gpp-tt','video/H261',
				'video/H263','video/H263-1998','video/H263-2000','video/H264','image/jpeg','image/gif','image/png','image/bmp',
				'text/vcard','text/csv','text/rtf','text/richtext','text/calendar','text/directory','application/pdf','application/doc','application/ms-doc','application/msword','application/pptx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/vnd.openxmlformats-officedocument.presentationml.presentation'
				],

				setDefaultNotesColor: '#ddd',

				colorSelected: "Grey",
				colorOptions: [{
					value: "#ddd",
					text: "Grey",
					src: "https://png.pngtree.com/png-clipart/20201029/ourmid/pngtree-circle-clipart-light-gray-round-png-image_2381992.jpg",
					},{
					value: "#adffad",
					text: "Green",
					src: "https://png.pngtree.com/png-clipart/20201029/ourmid/pngtree-circle-clipart-green-circle-png-image_2382000.jpg"
					},{
					value: "#ffff9d",
					text: "Yellow",
					src: "https://e7.pngegg.com/pngimages/210/560/png-clipart-computer-icons-circle-circle-orange-sphere-thumbnail.png"
					},{
					value: "#ffa9a9",
					text: "Red",
					src: "https://w7.pngwing.com/pngs/188/577/png-transparent-computer-icons-button-red-red-circle-sphere-magenta-red-thumbnail.png"
					}],
				disabledFullAddressField:true,
				selectedCCValue:[],
				screeningCriteria:{
					commission:'',
					fulltime:'',
					obtainlicense:'',
					startupcosts:'',
					status:'',
				},
				tempDtata:[],
			
			}
		},
		created(){
			this.tempDtata = this.sortedScreeningCriteria();
		}
	}
</script>

<style scoped>
/* .mgl-map-wrapper.custom-map canvas.mapboxgl-canvas {
    width: 100% !important;
    height: 100% !important;
}
#ProspectMapModal .modal-dialog.modal-lg {
    max-width: 900px !important;
    height: 550px !important;
}
#ProspectMapModal .modal-dialog.modal-lg .modal-content {
    height: 100%;
}
.mgl-map-wrapper.custom-map {
    height: calc(550px - 100px);
    width: 100%;
} */
/* .flex-grid{
	flex-wrap: wrap;width:100%;
}
.flex-grid > div{
	width:100%;
} */
.fromtopicker .form-control{
	font-size: 12px;
}
.fromtopicker .fromtopickerinput{
	width:180px;
}
.flex-grid textarea.flex-fill {
    max-width: 50%;padding-right:5px;
}

.flex-grid > fieldset{
    width: calc(50% - 60px);
	margin-bottom: 0;
}

.flex-grid > div {
    width: 60px;text-align: right;display: flex;align-items:flex-end;margin-left: 5px;
}
.bv-no-focus-ring fieldset:last-child{margin:0}
	.addButton {
		position: absolute;
		bottom: 10px;
		right: 10px;
		height: 4em;
		width: 4em;
		color: darkblue;
		background-color: white;
		box-shadow: 1px 1px 5px black;	
	}
	.w-auto {
		flex: 0 0 auto;
	}
	.noteItem {
		background-color: #E9ECEF;
	}
	.moveable {
		background-color: white;
	}
	.moveable:hover {
		cursor: all-scroll;
	}
	.input {
		resize: none;
	}
	.green_table {
		background: #8dce8d
	}
.wrapper-flex{
	position: relative;
}
.select-wrapper > div button {
    padding: 0 !important;
}
.dropdown-wrapper button {
    padding: 0px!important;
}
.select-wrapper {
    position: absolute;
    top: 0;
}
.wrapper-flex textarea.textarea-box {
    margin-top: 30px;
}


	
	b-button{display:flex;align-items:flex-end;margin-left:5px;}

	body { margin: 0; padding: 0; }
	/* #map { position: absolute; top: 0; bottom: 0; width: 100%; } */
	#map {
		position: absolute;
		top: 0;
		bottom: 0;
		width: 100%;
		left: 0;
		right: 0;
		padding: 10px !important;
		display: inline-block;
	}

	.distance-container {
		position: absolute;
		top: 10px;
		left: 50px;
		z-index: 1;
		font-weight: 600;
		background: #ccc;
		height: 22px;
		padding: 0px 5px;
		color: #fff;
	}
 
	.distance-container > * {
		background-color: rgba(0, 0, 0, 0.5);
		color: #fff;
		font-size: 11px;
		line-height: 18px;
		display: block;
		margin: 0;
		padding: 5px 10px;
		border-radius: 3px;
	}
	.custom-tag-content{
		margin-bottom: 10px;
	}
	.tags-custom {
		width: 100%;
		padding: 5px;
		border: 1px solid #dbdbdb;
		display: flex;flex-wrap: wrap;
		align-items: center;
		border-radius: 5px;
	}
	.tags-input .dropdown-menu {
		max-height: 200px; /* Adjust as necessary */
		overflow-y: auto;
	}
	.tags-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.custom-add-tags{
		color: rgb(50, 57, 140);
		cursor: pointer;
		/* text-align: center;
		align-items: center; */
		/* display: flex; */
		/* margin: 3px; */
		text-decoration: underline;
	}
	.tag-custom-wrapper button:span{
		outline: none;border: none;
	}
	.tag-custom-wrapper span{
		width: auto;color: #042b79;
		border: none;
		background: transparent;
		height: 20px;
		/* width: 20px; */
		display: flex;outline: none;
		align-items: center;
		/* transform: rotate(45deg); */
		font-weight: 700;
		cursor: pointer;
	}
	.tags-custom .tag-custom-wrapper {
		margin-right: 4px;margin-bottom: 4px;display:flex;padding: 3px 5px;
		border-radius: 4px;
		background: #f0f1f2;
	}

	.tags-custom .tag-custom-wrapper p {
		margin: 0;color: #042b79;padding-right: 5px;
		font-size: 12px;
		margin-right: 3px;
		
	}
	.ProspectActionDropDown{
		position: absolute;
		top:8px;
		right:15px;
		display: block;
		text-align: center;
		z-index: 2;
	}
	.button-container {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		/* padding: 0 5px; */
	}
	.edit-button {
		margin-left: 5px;
		padding: 0px 0px 2px 0px;
		display: flex;
		align-items: center;
	}
	.edit-button .v-icon {
		margin: 0;
	}
	.titleBtnContainer{
		display: flex;
		padding: 0 100px 0 20px;
		justify-content: space-around;
	}
	.editProspBtn{
		margin-top:5px;
		width: 25%;
	}
	.contactContainer{
		display: flex;
        flex-wrap: wrap;
		margin-bottom: 10px;
}
.contactInfo{
	width: 50%;
	padding: 0 10px 0px 0px;
}
.form-row{
	display: block !important;
}
.contactInfo .form-row legend{
	width: 100% !important;
	max-width: 100% !important;	
}
.screenCriteria{
	/* width: 50%;
	padding: 10px;
	border: 1px solid #878383; */
	margin-top: 12px;
    border-radius: 9px;
	margin-right: 10px; 
	flex: 1;
	display: flex;
	flex-direction: column;
	/* margin: 10px; */
	border: 1px solid #ccc; /* Optional: Add border for better visualization */
	padding: 10px;
}

.screeningTitle{
	display:flex
}

.screeningTitle{
	display:flex;
	justify-content: center;
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 12px;
}

.screeningData{
	margin: 0;
}

.screenDataRow{
	width:100%;
	margin-bottom:12px
}

.screenDataLabel{
	width:100%;
	font-weight:bold
}

.screenDataValue{
	width:100%;
	word-break: break-word;
}
.save-button{
	color: #007bff;
}

	/* .ProspectActionDropDown .ProspectActionDropDownBtn{
		background: red;
		color: #fff;
	}  */

	
	.ProspectActionDropDown{position: absolute;top:10px;right:15px;}
    .prspctcheckbox, .prspctcheckbox:focus-visible{width: 22px;height: 22px;margin-top: 8px;outline: none;}
    .prspctcheckboxinpt{float: right;width: 88%;margin-top: 1px; font-size: 12px;}
	.dateInputalign { width: 150px; }
	.scheduleReminderBtn {padding: 18px 8px!important; font-size: 11px!important; line-height: 18px;}
	.getCurrentTime { width: 175px; font-size: 12px;}
    .mb15{margin-bottom:15px;}
	
</style>
<style>
.vm--modal{
	/* top: 50px!important; */
    height: 600px!important;
    overflow-y: scroll!important;
	/* padding:20px; */
	font-weight: 500;
	border-radius:10px;
}
.clstopop{
	float: right;
    color: #000;
    opacity: .5;
	cursor:pointer;
}
.scheduleBtn{
	float: right!important;
    font-size: 13px!important;
    padding: 6px 15px!important;
}

.draghead{
	padding: 20px 20px 0px 20px;
}
.dragform{
	padding: 20px;
}
.vm--container{
	top: -100px!important;
}
.titlePI{
	margin-top: 10px;
}
.addtaskSavebtn button{
	font-size: 11px;
	width:48px;
	height:33px;
	padding: 7px!important;
}
.addtaskSavebtn{
	position: absolute;
	top:-5px;
	right:-15px;
}
.addNoteBtn{
	font-size: 11px!important;
	width:48px;
	height:32px;
	padding: 7px!important;
	margin-top: 5px;
}
.notesTableUI{
	margin-bottom: 70px!important;
}
div.notesTableUIList{
	margin-bottom: 70px!important;
}
.fileUploadNotes{
	float: right;
    padding: 5px!important;
    border: none!important;
}
.ProspectInfoInputs select{
	height:35px;
}
.tagsDivUI .custom-tag-content{
	margin-bottom: 0px;
}
.tagsDivUI .tags-input-wrapper-default{
	margin: 0px 0px 0px 3px;
	height: 37px;
    padding: 7px;	
}
.prspctcheckboxinpt label.form-control{
	padding-top:7px
}
.prspctcheckboxinpt{
	min-height: 35px!important;
}
.CompetitorNameInputUI{
	margin-top: 7px;
	margin-bottom: 10px;
}
.timeInputUI{
	margin-top: 5px;
}
.timeInputUI .getCurrentTime{
	height: 35px;
}
.timeInputUI label.form-control{
	padding-top: 7px;	
}
.taskdatetimeinputUI .b-form-btn-label-control.form-control{
	min-height:35px;
}
.taskdatetimeinputUI label.form-control{
	padding-top: 5px;	
}
.taskdatetimeinputUI .form-group{
	margin: 8px 0px;
}
.addressSubmitBtn{
	float: right;
    font-size: 13px!important;
    padding: 8px 24px!important;
}
.tablecdwi.customDropWithImg{
	width: 30px;
    border-radius: 100px;
    height: 30px;
	border:1px solid #eaeaea;
}
.tablecdwi.notesdrpdwn{
	width: 75px !important;
}
.customDropWithImg img{
	width: 20px;
}
.customDropWithImg{
    width: 38px;
    border-radius: 100px;
    height: 38px;
	outline: none;
    box-shadow: none;
}
.customDropWithImg button,
.customDropWithImg button:focus, 
.customDropWithImg button:hover,
.customDropWithImg button:active,
.customDropWithImg button.btn-secondary:not(:disabled):not(.disabled):active{
	font-size: 10px;
	padding: 0px;
	margin-top: 0px;
	background-color: transparent;
	border:transparent;
	color: #000;
	outline: none;
    box-shadow: none;
}
.customDropWithImg ul{
	min-width: 3rem;
	padding: 0;
}
.customDropWithImg {
	background-color: #ddd;
	border:#ddd;
}
.copybtn{
	position: absolute;
    right: 12px;
    z-index: 9;
    background: #878787;
    padding: 1px 5px;
    border-radius: 3px;
    bottom: 7px;
    cursor: pointer;
    color: #fff;
    font-size: 12px;
}
.flex-box-layout {
    display: grid;
    grid-template-columns: 5fr 4fr 2fr;
	gap: 7px;
}
.copiedspan{
	background: #86d386;
	color: #fff;
	padding: 2px 10px;
	border-radius: 2px;
	font-size: 11px;
	margin-top: 2px;
	position: absolute;
	right: 0;
}
</style>
